/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const ride_tracker = $root.ride_tracker = (() => {

    /**
     * Namespace ride_tracker.
     * @exports ride_tracker
     * @namespace
     */
    const ride_tracker = {};

    ride_tracker.RideTracker = (function() {

        /**
         * Constructs a new RideTracker service.
         * @memberof ride_tracker
         * @classdesc Represents a RideTracker
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function RideTracker(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (RideTracker.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = RideTracker;

        /**
         * Creates new RideTracker service using the specified rpc implementation.
         * @function create
         * @memberof ride_tracker.RideTracker
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {RideTracker} RPC service. Useful where requests and/or responses are streamed.
         */
        RideTracker.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link ride_tracker.RideTracker#createTracking}.
         * @memberof ride_tracker.RideTracker
         * @typedef CreateTrackingCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {ride_tracker.CreateTrackingResponse} [response] CreateTrackingResponse
         */

        /**
         * Calls CreateTracking.
         * @function createTracking
         * @memberof ride_tracker.RideTracker
         * @instance
         * @param {ride_tracker.ICreateTrackingRequest} request CreateTrackingRequest message or plain object
         * @param {ride_tracker.RideTracker.CreateTrackingCallback} callback Node-style callback called with the error, if any, and CreateTrackingResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(RideTracker.prototype.createTracking = function createTracking(request, callback) {
            return this.rpcCall(createTracking, $root.ride_tracker.CreateTrackingRequest, $root.ride_tracker.CreateTrackingResponse, request, callback);
        }, "name", { value: "CreateTracking" });

        /**
         * Calls CreateTracking.
         * @function createTracking
         * @memberof ride_tracker.RideTracker
         * @instance
         * @param {ride_tracker.ICreateTrackingRequest} request CreateTrackingRequest message or plain object
         * @returns {Promise<ride_tracker.CreateTrackingResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link ride_tracker.RideTracker#getTracking}.
         * @memberof ride_tracker.RideTracker
         * @typedef GetTrackingCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {ride_tracker.GetTrackingResponse} [response] GetTrackingResponse
         */

        /**
         * Calls GetTracking.
         * @function getTracking
         * @memberof ride_tracker.RideTracker
         * @instance
         * @param {ride_tracker.IGetTrackingRequest} request GetTrackingRequest message or plain object
         * @param {ride_tracker.RideTracker.GetTrackingCallback} callback Node-style callback called with the error, if any, and GetTrackingResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(RideTracker.prototype.getTracking = function getTracking(request, callback) {
            return this.rpcCall(getTracking, $root.ride_tracker.GetTrackingRequest, $root.ride_tracker.GetTrackingResponse, request, callback);
        }, "name", { value: "GetTracking" });

        /**
         * Calls GetTracking.
         * @function getTracking
         * @memberof ride_tracker.RideTracker
         * @instance
         * @param {ride_tracker.IGetTrackingRequest} request GetTrackingRequest message or plain object
         * @returns {Promise<ride_tracker.GetTrackingResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link ride_tracker.RideTracker#pushEvent}.
         * @memberof ride_tracker.RideTracker
         * @typedef PushEventCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {google.protobuf.Empty} [response] Empty
         */

        /**
         * Calls PushEvent.
         * @function pushEvent
         * @memberof ride_tracker.RideTracker
         * @instance
         * @param {ride_tracker.IPushEventRequest} request PushEventRequest message or plain object
         * @param {ride_tracker.RideTracker.PushEventCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(RideTracker.prototype.pushEvent = function pushEvent(request, callback) {
            return this.rpcCall(pushEvent, $root.ride_tracker.PushEventRequest, $root.google.protobuf.Empty, request, callback);
        }, "name", { value: "PushEvent" });

        /**
         * Calls PushEvent.
         * @function pushEvent
         * @memberof ride_tracker.RideTracker
         * @instance
         * @param {ride_tracker.IPushEventRequest} request PushEventRequest message or plain object
         * @returns {Promise<google.protobuf.Empty>} Promise
         * @variation 2
         */

        return RideTracker;
    })();

    ride_tracker.CreateTrackingRequest = (function() {

        /**
         * Properties of a CreateTrackingRequest.
         * @memberof ride_tracker
         * @interface ICreateTrackingRequest
         * @property {number|null} [orderId] CreateTrackingRequest orderId
         * @property {string|null} [riderPhoneNumber] CreateTrackingRequest riderPhoneNumber
         * @property {string|null} [rideUuid] CreateTrackingRequest rideUuid
         * @property {string|null} [env] CreateTrackingRequest env
         * @property {string|null} [locale] CreateTrackingRequest locale
         * @property {boolean|null} [isShareRide] CreateTrackingRequest isShareRide
         */

        /**
         * Constructs a new CreateTrackingRequest.
         * @memberof ride_tracker
         * @classdesc Represents a CreateTrackingRequest.
         * @implements ICreateTrackingRequest
         * @constructor
         * @param {ride_tracker.ICreateTrackingRequest=} [p] Properties to set
         */
        function CreateTrackingRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateTrackingRequest orderId.
         * @member {number} orderId
         * @memberof ride_tracker.CreateTrackingRequest
         * @instance
         */
        CreateTrackingRequest.prototype.orderId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CreateTrackingRequest riderPhoneNumber.
         * @member {string} riderPhoneNumber
         * @memberof ride_tracker.CreateTrackingRequest
         * @instance
         */
        CreateTrackingRequest.prototype.riderPhoneNumber = "";

        /**
         * CreateTrackingRequest rideUuid.
         * @member {string} rideUuid
         * @memberof ride_tracker.CreateTrackingRequest
         * @instance
         */
        CreateTrackingRequest.prototype.rideUuid = "";

        /**
         * CreateTrackingRequest env.
         * @member {string} env
         * @memberof ride_tracker.CreateTrackingRequest
         * @instance
         */
        CreateTrackingRequest.prototype.env = "";

        /**
         * CreateTrackingRequest locale.
         * @member {string} locale
         * @memberof ride_tracker.CreateTrackingRequest
         * @instance
         */
        CreateTrackingRequest.prototype.locale = "";

        /**
         * CreateTrackingRequest isShareRide.
         * @member {boolean} isShareRide
         * @memberof ride_tracker.CreateTrackingRequest
         * @instance
         */
        CreateTrackingRequest.prototype.isShareRide = false;

        /**
         * Creates a new CreateTrackingRequest instance using the specified properties.
         * @function create
         * @memberof ride_tracker.CreateTrackingRequest
         * @static
         * @param {ride_tracker.ICreateTrackingRequest=} [properties] Properties to set
         * @returns {ride_tracker.CreateTrackingRequest} CreateTrackingRequest instance
         */
        CreateTrackingRequest.create = function create(properties) {
            return new CreateTrackingRequest(properties);
        };

        /**
         * Encodes the specified CreateTrackingRequest message. Does not implicitly {@link ride_tracker.CreateTrackingRequest.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.CreateTrackingRequest
         * @static
         * @param {ride_tracker.ICreateTrackingRequest} m CreateTrackingRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateTrackingRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.orderId != null && Object.hasOwnProperty.call(m, "orderId"))
                w.uint32(8).int64(m.orderId);
            if (m.riderPhoneNumber != null && Object.hasOwnProperty.call(m, "riderPhoneNumber"))
                w.uint32(18).string(m.riderPhoneNumber);
            if (m.rideUuid != null && Object.hasOwnProperty.call(m, "rideUuid"))
                w.uint32(26).string(m.rideUuid);
            if (m.env != null && Object.hasOwnProperty.call(m, "env"))
                w.uint32(34).string(m.env);
            if (m.locale != null && Object.hasOwnProperty.call(m, "locale"))
                w.uint32(42).string(m.locale);
            if (m.isShareRide != null && Object.hasOwnProperty.call(m, "isShareRide"))
                w.uint32(48).bool(m.isShareRide);
            return w;
        };

        /**
         * Decodes a CreateTrackingRequest message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.CreateTrackingRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.CreateTrackingRequest} CreateTrackingRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateTrackingRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.CreateTrackingRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.orderId = r.int64();
                    break;
                case 2:
                    m.riderPhoneNumber = r.string();
                    break;
                case 3:
                    m.rideUuid = r.string();
                    break;
                case 4:
                    m.env = r.string();
                    break;
                case 5:
                    m.locale = r.string();
                    break;
                case 6:
                    m.isShareRide = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a CreateTrackingRequest message.
         * @function verify
         * @memberof ride_tracker.CreateTrackingRequest
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateTrackingRequest.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.orderId != null && m.hasOwnProperty("orderId")) {
                if (!$util.isInteger(m.orderId) && !(m.orderId && $util.isInteger(m.orderId.low) && $util.isInteger(m.orderId.high)))
                    return "orderId: integer|Long expected";
            }
            if (m.riderPhoneNumber != null && m.hasOwnProperty("riderPhoneNumber")) {
                if (!$util.isString(m.riderPhoneNumber))
                    return "riderPhoneNumber: string expected";
            }
            if (m.rideUuid != null && m.hasOwnProperty("rideUuid")) {
                if (!$util.isString(m.rideUuid))
                    return "rideUuid: string expected";
            }
            if (m.env != null && m.hasOwnProperty("env")) {
                if (!$util.isString(m.env))
                    return "env: string expected";
            }
            if (m.locale != null && m.hasOwnProperty("locale")) {
                if (!$util.isString(m.locale))
                    return "locale: string expected";
            }
            if (m.isShareRide != null && m.hasOwnProperty("isShareRide")) {
                if (typeof m.isShareRide !== "boolean")
                    return "isShareRide: boolean expected";
            }
            return null;
        };

        /**
         * Creates a CreateTrackingRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.CreateTrackingRequest
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.CreateTrackingRequest} CreateTrackingRequest
         */
        CreateTrackingRequest.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.CreateTrackingRequest)
                return d;
            var m = new $root.ride_tracker.CreateTrackingRequest();
            if (d.orderId != null) {
                if ($util.Long)
                    (m.orderId = $util.Long.fromValue(d.orderId)).unsigned = false;
                else if (typeof d.orderId === "string")
                    m.orderId = parseInt(d.orderId, 10);
                else if (typeof d.orderId === "number")
                    m.orderId = d.orderId;
                else if (typeof d.orderId === "object")
                    m.orderId = new $util.LongBits(d.orderId.low >>> 0, d.orderId.high >>> 0).toNumber();
            }
            if (d.riderPhoneNumber != null) {
                m.riderPhoneNumber = String(d.riderPhoneNumber);
            }
            if (d.rideUuid != null) {
                m.rideUuid = String(d.rideUuid);
            }
            if (d.env != null) {
                m.env = String(d.env);
            }
            if (d.locale != null) {
                m.locale = String(d.locale);
            }
            if (d.isShareRide != null) {
                m.isShareRide = Boolean(d.isShareRide);
            }
            return m;
        };

        /**
         * Creates a plain object from a CreateTrackingRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.CreateTrackingRequest
         * @static
         * @param {ride_tracker.CreateTrackingRequest} m CreateTrackingRequest
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateTrackingRequest.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, false);
                    d.orderId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.orderId = o.longs === String ? "0" : 0;
                d.riderPhoneNumber = "";
                d.rideUuid = "";
                d.env = "";
                d.locale = "";
                d.isShareRide = false;
            }
            if (m.orderId != null && m.hasOwnProperty("orderId")) {
                if (typeof m.orderId === "number")
                    d.orderId = o.longs === String ? String(m.orderId) : m.orderId;
                else
                    d.orderId = o.longs === String ? $util.Long.prototype.toString.call(m.orderId) : o.longs === Number ? new $util.LongBits(m.orderId.low >>> 0, m.orderId.high >>> 0).toNumber() : m.orderId;
            }
            if (m.riderPhoneNumber != null && m.hasOwnProperty("riderPhoneNumber")) {
                d.riderPhoneNumber = m.riderPhoneNumber;
            }
            if (m.rideUuid != null && m.hasOwnProperty("rideUuid")) {
                d.rideUuid = m.rideUuid;
            }
            if (m.env != null && m.hasOwnProperty("env")) {
                d.env = m.env;
            }
            if (m.locale != null && m.hasOwnProperty("locale")) {
                d.locale = m.locale;
            }
            if (m.isShareRide != null && m.hasOwnProperty("isShareRide")) {
                d.isShareRide = m.isShareRide;
            }
            return d;
        };

        /**
         * Converts this CreateTrackingRequest to JSON.
         * @function toJSON
         * @memberof ride_tracker.CreateTrackingRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateTrackingRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateTrackingRequest;
    })();

    ride_tracker.CreateTrackingResponse = (function() {

        /**
         * Properties of a CreateTrackingResponse.
         * @memberof ride_tracker
         * @interface ICreateTrackingResponse
         * @property {string|null} [trackingId] CreateTrackingResponse trackingId
         * @property {string|null} [url] CreateTrackingResponse url
         */

        /**
         * Constructs a new CreateTrackingResponse.
         * @memberof ride_tracker
         * @classdesc Represents a CreateTrackingResponse.
         * @implements ICreateTrackingResponse
         * @constructor
         * @param {ride_tracker.ICreateTrackingResponse=} [p] Properties to set
         */
        function CreateTrackingResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateTrackingResponse trackingId.
         * @member {string} trackingId
         * @memberof ride_tracker.CreateTrackingResponse
         * @instance
         */
        CreateTrackingResponse.prototype.trackingId = "";

        /**
         * CreateTrackingResponse url.
         * @member {string} url
         * @memberof ride_tracker.CreateTrackingResponse
         * @instance
         */
        CreateTrackingResponse.prototype.url = "";

        /**
         * Creates a new CreateTrackingResponse instance using the specified properties.
         * @function create
         * @memberof ride_tracker.CreateTrackingResponse
         * @static
         * @param {ride_tracker.ICreateTrackingResponse=} [properties] Properties to set
         * @returns {ride_tracker.CreateTrackingResponse} CreateTrackingResponse instance
         */
        CreateTrackingResponse.create = function create(properties) {
            return new CreateTrackingResponse(properties);
        };

        /**
         * Encodes the specified CreateTrackingResponse message. Does not implicitly {@link ride_tracker.CreateTrackingResponse.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.CreateTrackingResponse
         * @static
         * @param {ride_tracker.ICreateTrackingResponse} m CreateTrackingResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateTrackingResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.trackingId != null && Object.hasOwnProperty.call(m, "trackingId"))
                w.uint32(10).string(m.trackingId);
            if (m.url != null && Object.hasOwnProperty.call(m, "url"))
                w.uint32(18).string(m.url);
            return w;
        };

        /**
         * Decodes a CreateTrackingResponse message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.CreateTrackingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.CreateTrackingResponse} CreateTrackingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateTrackingResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.CreateTrackingResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.trackingId = r.string();
                    break;
                case 2:
                    m.url = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a CreateTrackingResponse message.
         * @function verify
         * @memberof ride_tracker.CreateTrackingResponse
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateTrackingResponse.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.trackingId != null && m.hasOwnProperty("trackingId")) {
                if (!$util.isString(m.trackingId))
                    return "trackingId: string expected";
            }
            if (m.url != null && m.hasOwnProperty("url")) {
                if (!$util.isString(m.url))
                    return "url: string expected";
            }
            return null;
        };

        /**
         * Creates a CreateTrackingResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.CreateTrackingResponse
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.CreateTrackingResponse} CreateTrackingResponse
         */
        CreateTrackingResponse.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.CreateTrackingResponse)
                return d;
            var m = new $root.ride_tracker.CreateTrackingResponse();
            if (d.trackingId != null) {
                m.trackingId = String(d.trackingId);
            }
            if (d.url != null) {
                m.url = String(d.url);
            }
            return m;
        };

        /**
         * Creates a plain object from a CreateTrackingResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.CreateTrackingResponse
         * @static
         * @param {ride_tracker.CreateTrackingResponse} m CreateTrackingResponse
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateTrackingResponse.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.trackingId = "";
                d.url = "";
            }
            if (m.trackingId != null && m.hasOwnProperty("trackingId")) {
                d.trackingId = m.trackingId;
            }
            if (m.url != null && m.hasOwnProperty("url")) {
                d.url = m.url;
            }
            return d;
        };

        /**
         * Converts this CreateTrackingResponse to JSON.
         * @function toJSON
         * @memberof ride_tracker.CreateTrackingResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateTrackingResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateTrackingResponse;
    })();

    ride_tracker.GetTrackingRequest = (function() {

        /**
         * Properties of a GetTrackingRequest.
         * @memberof ride_tracker
         * @interface IGetTrackingRequest
         * @property {string|null} [trackingId] GetTrackingRequest trackingId
         * @property {string|null} [locale] GetTrackingRequest locale
         */

        /**
         * Constructs a new GetTrackingRequest.
         * @memberof ride_tracker
         * @classdesc Represents a GetTrackingRequest.
         * @implements IGetTrackingRequest
         * @constructor
         * @param {ride_tracker.IGetTrackingRequest=} [p] Properties to set
         */
        function GetTrackingRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetTrackingRequest trackingId.
         * @member {string} trackingId
         * @memberof ride_tracker.GetTrackingRequest
         * @instance
         */
        GetTrackingRequest.prototype.trackingId = "";

        /**
         * GetTrackingRequest locale.
         * @member {string} locale
         * @memberof ride_tracker.GetTrackingRequest
         * @instance
         */
        GetTrackingRequest.prototype.locale = "";

        /**
         * Creates a new GetTrackingRequest instance using the specified properties.
         * @function create
         * @memberof ride_tracker.GetTrackingRequest
         * @static
         * @param {ride_tracker.IGetTrackingRequest=} [properties] Properties to set
         * @returns {ride_tracker.GetTrackingRequest} GetTrackingRequest instance
         */
        GetTrackingRequest.create = function create(properties) {
            return new GetTrackingRequest(properties);
        };

        /**
         * Encodes the specified GetTrackingRequest message. Does not implicitly {@link ride_tracker.GetTrackingRequest.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.GetTrackingRequest
         * @static
         * @param {ride_tracker.IGetTrackingRequest} m GetTrackingRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetTrackingRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.trackingId != null && Object.hasOwnProperty.call(m, "trackingId"))
                w.uint32(10).string(m.trackingId);
            if (m.locale != null && Object.hasOwnProperty.call(m, "locale"))
                w.uint32(18).string(m.locale);
            return w;
        };

        /**
         * Decodes a GetTrackingRequest message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.GetTrackingRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.GetTrackingRequest} GetTrackingRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetTrackingRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.GetTrackingRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.trackingId = r.string();
                    break;
                case 2:
                    m.locale = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a GetTrackingRequest message.
         * @function verify
         * @memberof ride_tracker.GetTrackingRequest
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetTrackingRequest.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.trackingId != null && m.hasOwnProperty("trackingId")) {
                if (!$util.isString(m.trackingId))
                    return "trackingId: string expected";
            }
            if (m.locale != null && m.hasOwnProperty("locale")) {
                if (!$util.isString(m.locale))
                    return "locale: string expected";
            }
            return null;
        };

        /**
         * Creates a GetTrackingRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.GetTrackingRequest
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.GetTrackingRequest} GetTrackingRequest
         */
        GetTrackingRequest.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.GetTrackingRequest)
                return d;
            var m = new $root.ride_tracker.GetTrackingRequest();
            if (d.trackingId != null) {
                m.trackingId = String(d.trackingId);
            }
            if (d.locale != null) {
                m.locale = String(d.locale);
            }
            return m;
        };

        /**
         * Creates a plain object from a GetTrackingRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.GetTrackingRequest
         * @static
         * @param {ride_tracker.GetTrackingRequest} m GetTrackingRequest
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTrackingRequest.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.trackingId = "";
                d.locale = "";
            }
            if (m.trackingId != null && m.hasOwnProperty("trackingId")) {
                d.trackingId = m.trackingId;
            }
            if (m.locale != null && m.hasOwnProperty("locale")) {
                d.locale = m.locale;
            }
            return d;
        };

        /**
         * Converts this GetTrackingRequest to JSON.
         * @function toJSON
         * @memberof ride_tracker.GetTrackingRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTrackingRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTrackingRequest;
    })();

    ride_tracker.GetTrackingResponse = (function() {

        /**
         * Properties of a GetTrackingResponse.
         * @memberof ride_tracker
         * @interface IGetTrackingResponse
         * @property {number|null} [orderId] GetTrackingResponse orderId
         * @property {ride_tracker.OrderStatus|null} [orderStatus] GetTrackingResponse orderStatus
         * @property {Array.<ride_tracker.IStop>|null} [stops] GetTrackingResponse stops
         * @property {string|null} [rideStartPinCode] GetTrackingResponse rideStartPinCode
         * @property {string|null} [country] GetTrackingResponse country
         * @property {ride_tracker.IDivision|null} [division] GetTrackingResponse division
         * @property {ride_tracker.IDriver|null} [driver] GetTrackingResponse driver
         * @property {ride_tracker.IRouteDetails|null} [routeDetails] GetTrackingResponse routeDetails
         * @property {ride_tracker.IChangeHistory|null} [changeHistory] GetTrackingResponse changeHistory
         * @property {ride_tracker.RideType|null} [type] GetTrackingResponse type
         * @property {ride_tracker.ICompany|null} [company] GetTrackingResponse company
         * @property {ride_tracker.CanceledBy|null} [canceledBy] GetTrackingResponse canceledBy
         * @property {boolean|null} [isMeetAndGreet] GetTrackingResponse isMeetAndGreet
         * @property {string|null} [pickupInstructions] GetTrackingResponse pickupInstructions
         * @property {boolean|null} [isShareRide] GetTrackingResponse isShareRide
         */

        /**
         * Constructs a new GetTrackingResponse.
         * @memberof ride_tracker
         * @classdesc Represents a GetTrackingResponse.
         * @implements IGetTrackingResponse
         * @constructor
         * @param {ride_tracker.IGetTrackingResponse=} [p] Properties to set
         */
        function GetTrackingResponse(p) {
            this.stops = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetTrackingResponse orderId.
         * @member {number} orderId
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.orderId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GetTrackingResponse orderStatus.
         * @member {ride_tracker.OrderStatus} orderStatus
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.orderStatus = 0;

        /**
         * GetTrackingResponse stops.
         * @member {Array.<ride_tracker.IStop>} stops
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.stops = $util.emptyArray;

        /**
         * GetTrackingResponse rideStartPinCode.
         * @member {string} rideStartPinCode
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.rideStartPinCode = "";

        /**
         * GetTrackingResponse country.
         * @member {string} country
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.country = "";

        /**
         * GetTrackingResponse division.
         * @member {ride_tracker.IDivision|null|undefined} division
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.division = null;

        /**
         * GetTrackingResponse driver.
         * @member {ride_tracker.IDriver|null|undefined} driver
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.driver = null;

        /**
         * GetTrackingResponse routeDetails.
         * @member {ride_tracker.IRouteDetails|null|undefined} routeDetails
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.routeDetails = null;

        /**
         * GetTrackingResponse changeHistory.
         * @member {ride_tracker.IChangeHistory|null|undefined} changeHistory
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.changeHistory = null;

        /**
         * GetTrackingResponse type.
         * @member {ride_tracker.RideType} type
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.type = 0;

        /**
         * GetTrackingResponse company.
         * @member {ride_tracker.ICompany|null|undefined} company
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.company = null;

        /**
         * GetTrackingResponse canceledBy.
         * @member {ride_tracker.CanceledBy} canceledBy
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.canceledBy = 0;

        /**
         * GetTrackingResponse isMeetAndGreet.
         * @member {boolean} isMeetAndGreet
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.isMeetAndGreet = false;

        /**
         * GetTrackingResponse pickupInstructions.
         * @member {string} pickupInstructions
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.pickupInstructions = "";

        /**
         * GetTrackingResponse isShareRide.
         * @member {boolean} isShareRide
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         */
        GetTrackingResponse.prototype.isShareRide = false;

        /**
         * Creates a new GetTrackingResponse instance using the specified properties.
         * @function create
         * @memberof ride_tracker.GetTrackingResponse
         * @static
         * @param {ride_tracker.IGetTrackingResponse=} [properties] Properties to set
         * @returns {ride_tracker.GetTrackingResponse} GetTrackingResponse instance
         */
        GetTrackingResponse.create = function create(properties) {
            return new GetTrackingResponse(properties);
        };

        /**
         * Encodes the specified GetTrackingResponse message. Does not implicitly {@link ride_tracker.GetTrackingResponse.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.GetTrackingResponse
         * @static
         * @param {ride_tracker.IGetTrackingResponse} m GetTrackingResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetTrackingResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.orderId != null && Object.hasOwnProperty.call(m, "orderId"))
                w.uint32(8).int64(m.orderId);
            if (m.orderStatus != null && Object.hasOwnProperty.call(m, "orderStatus"))
                w.uint32(16).int32(m.orderStatus);
            if (m.stops != null && m.stops.length) {
                for (var i = 0; i < m.stops.length; ++i)
                    $root.ride_tracker.Stop.encode(m.stops[i], w.uint32(26).fork()).ldelim();
            }
            if (m.rideStartPinCode != null && Object.hasOwnProperty.call(m, "rideStartPinCode"))
                w.uint32(42).string(m.rideStartPinCode);
            if (m.country != null && Object.hasOwnProperty.call(m, "country"))
                w.uint32(50).string(m.country);
            if (m.division != null && Object.hasOwnProperty.call(m, "division"))
                $root.ride_tracker.Division.encode(m.division, w.uint32(58).fork()).ldelim();
            if (m.driver != null && Object.hasOwnProperty.call(m, "driver"))
                $root.ride_tracker.Driver.encode(m.driver, w.uint32(66).fork()).ldelim();
            if (m.routeDetails != null && Object.hasOwnProperty.call(m, "routeDetails"))
                $root.ride_tracker.RouteDetails.encode(m.routeDetails, w.uint32(74).fork()).ldelim();
            if (m.changeHistory != null && Object.hasOwnProperty.call(m, "changeHistory"))
                $root.ride_tracker.ChangeHistory.encode(m.changeHistory, w.uint32(82).fork()).ldelim();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(88).int32(m.type);
            if (m.company != null && Object.hasOwnProperty.call(m, "company"))
                $root.ride_tracker.Company.encode(m.company, w.uint32(98).fork()).ldelim();
            if (m.canceledBy != null && Object.hasOwnProperty.call(m, "canceledBy"))
                w.uint32(104).int32(m.canceledBy);
            if (m.isMeetAndGreet != null && Object.hasOwnProperty.call(m, "isMeetAndGreet"))
                w.uint32(112).bool(m.isMeetAndGreet);
            if (m.pickupInstructions != null && Object.hasOwnProperty.call(m, "pickupInstructions"))
                w.uint32(122).string(m.pickupInstructions);
            if (m.isShareRide != null && Object.hasOwnProperty.call(m, "isShareRide"))
                w.uint32(128).bool(m.isShareRide);
            return w;
        };

        /**
         * Decodes a GetTrackingResponse message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.GetTrackingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.GetTrackingResponse} GetTrackingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetTrackingResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.GetTrackingResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.orderId = r.int64();
                    break;
                case 2:
                    m.orderStatus = r.int32();
                    break;
                case 3:
                    if (!(m.stops && m.stops.length))
                        m.stops = [];
                    m.stops.push($root.ride_tracker.Stop.decode(r, r.uint32()));
                    break;
                case 5:
                    m.rideStartPinCode = r.string();
                    break;
                case 6:
                    m.country = r.string();
                    break;
                case 7:
                    m.division = $root.ride_tracker.Division.decode(r, r.uint32());
                    break;
                case 8:
                    m.driver = $root.ride_tracker.Driver.decode(r, r.uint32());
                    break;
                case 9:
                    m.routeDetails = $root.ride_tracker.RouteDetails.decode(r, r.uint32());
                    break;
                case 10:
                    m.changeHistory = $root.ride_tracker.ChangeHistory.decode(r, r.uint32());
                    break;
                case 11:
                    m.type = r.int32();
                    break;
                case 12:
                    m.company = $root.ride_tracker.Company.decode(r, r.uint32());
                    break;
                case 13:
                    m.canceledBy = r.int32();
                    break;
                case 14:
                    m.isMeetAndGreet = r.bool();
                    break;
                case 15:
                    m.pickupInstructions = r.string();
                    break;
                case 16:
                    m.isShareRide = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a GetTrackingResponse message.
         * @function verify
         * @memberof ride_tracker.GetTrackingResponse
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetTrackingResponse.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.orderId != null && m.hasOwnProperty("orderId")) {
                if (!$util.isInteger(m.orderId) && !(m.orderId && $util.isInteger(m.orderId.low) && $util.isInteger(m.orderId.high)))
                    return "orderId: integer|Long expected";
            }
            if (m.orderStatus != null && m.hasOwnProperty("orderStatus")) {
                switch (m.orderStatus) {
                default:
                    return "orderStatus: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                    break;
                }
            }
            if (m.stops != null && m.hasOwnProperty("stops")) {
                if (!Array.isArray(m.stops))
                    return "stops: array expected";
                for (var i = 0; i < m.stops.length; ++i) {
                    {
                        var e = $root.ride_tracker.Stop.verify(m.stops[i]);
                        if (e)
                            return "stops." + e;
                    }
                }
            }
            if (m.rideStartPinCode != null && m.hasOwnProperty("rideStartPinCode")) {
                if (!$util.isString(m.rideStartPinCode))
                    return "rideStartPinCode: string expected";
            }
            if (m.country != null && m.hasOwnProperty("country")) {
                if (!$util.isString(m.country))
                    return "country: string expected";
            }
            if (m.division != null && m.hasOwnProperty("division")) {
                {
                    var e = $root.ride_tracker.Division.verify(m.division);
                    if (e)
                        return "division." + e;
                }
            }
            if (m.driver != null && m.hasOwnProperty("driver")) {
                {
                    var e = $root.ride_tracker.Driver.verify(m.driver);
                    if (e)
                        return "driver." + e;
                }
            }
            if (m.routeDetails != null && m.hasOwnProperty("routeDetails")) {
                {
                    var e = $root.ride_tracker.RouteDetails.verify(m.routeDetails);
                    if (e)
                        return "routeDetails." + e;
                }
            }
            if (m.changeHistory != null && m.hasOwnProperty("changeHistory")) {
                {
                    var e = $root.ride_tracker.ChangeHistory.verify(m.changeHistory);
                    if (e)
                        return "changeHistory." + e;
                }
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            }
            if (m.company != null && m.hasOwnProperty("company")) {
                {
                    var e = $root.ride_tracker.Company.verify(m.company);
                    if (e)
                        return "company." + e;
                }
            }
            if (m.canceledBy != null && m.hasOwnProperty("canceledBy")) {
                switch (m.canceledBy) {
                default:
                    return "canceledBy: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.isMeetAndGreet != null && m.hasOwnProperty("isMeetAndGreet")) {
                if (typeof m.isMeetAndGreet !== "boolean")
                    return "isMeetAndGreet: boolean expected";
            }
            if (m.pickupInstructions != null && m.hasOwnProperty("pickupInstructions")) {
                if (!$util.isString(m.pickupInstructions))
                    return "pickupInstructions: string expected";
            }
            if (m.isShareRide != null && m.hasOwnProperty("isShareRide")) {
                if (typeof m.isShareRide !== "boolean")
                    return "isShareRide: boolean expected";
            }
            return null;
        };

        /**
         * Creates a GetTrackingResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.GetTrackingResponse
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.GetTrackingResponse} GetTrackingResponse
         */
        GetTrackingResponse.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.GetTrackingResponse)
                return d;
            var m = new $root.ride_tracker.GetTrackingResponse();
            if (d.orderId != null) {
                if ($util.Long)
                    (m.orderId = $util.Long.fromValue(d.orderId)).unsigned = false;
                else if (typeof d.orderId === "string")
                    m.orderId = parseInt(d.orderId, 10);
                else if (typeof d.orderId === "number")
                    m.orderId = d.orderId;
                else if (typeof d.orderId === "object")
                    m.orderId = new $util.LongBits(d.orderId.low >>> 0, d.orderId.high >>> 0).toNumber();
            }
            switch (d.orderStatus) {
            case "ORDER_STATUS_UNSPECIFIED":
            case 0:
                m.orderStatus = 0;
                break;
            case "ORDER_STATUS_ROUTING":
            case 1:
                m.orderStatus = 1;
                break;
            case "ORDER_STATUS_PENDING":
            case 2:
                m.orderStatus = 2;
                break;
            case "ORDER_STATUS_CONFIRMED":
            case 3:
                m.orderStatus = 3;
                break;
            case "ORDER_STATUS_CANCELLED":
            case 4:
                m.orderStatus = 4;
                break;
            case "ORDER_STATUS_WAITING":
            case 5:
                m.orderStatus = 5;
                break;
            case "ORDER_STATUS_DRIVING":
            case 6:
                m.orderStatus = 6;
                break;
            case "ORDER_STATUS_COMPLETED":
            case 7:
                m.orderStatus = 7;
                break;
            case "ORDER_STATUS_CARE_REQUESTED":
            case 8:
                m.orderStatus = 8;
                break;
            case "ORDER_STATUS_REJECTED":
            case 9:
                m.orderStatus = 9;
                break;
            case "ORDER_STATUS_ASSIGNED":
            case 10:
                m.orderStatus = 10;
                break;
            case "ORDER_STATUS_RESERVED":
            case 11:
                m.orderStatus = 11;
                break;
            case "ORDER_STATUS_UNRESERVED":
            case 12:
                m.orderStatus = 12;
                break;
            }
            if (d.stops) {
                if (!Array.isArray(d.stops))
                    throw TypeError(".ride_tracker.GetTrackingResponse.stops: array expected");
                m.stops = [];
                for (var i = 0; i < d.stops.length; ++i) {
                    if (typeof d.stops[i] !== "object")
                        throw TypeError(".ride_tracker.GetTrackingResponse.stops: object expected");
                    m.stops[i] = $root.ride_tracker.Stop.fromObject(d.stops[i]);
                }
            }
            if (d.rideStartPinCode != null) {
                m.rideStartPinCode = String(d.rideStartPinCode);
            }
            if (d.country != null) {
                m.country = String(d.country);
            }
            if (d.division != null) {
                if (typeof d.division !== "object")
                    throw TypeError(".ride_tracker.GetTrackingResponse.division: object expected");
                m.division = $root.ride_tracker.Division.fromObject(d.division);
            }
            if (d.driver != null) {
                if (typeof d.driver !== "object")
                    throw TypeError(".ride_tracker.GetTrackingResponse.driver: object expected");
                m.driver = $root.ride_tracker.Driver.fromObject(d.driver);
            }
            if (d.routeDetails != null) {
                if (typeof d.routeDetails !== "object")
                    throw TypeError(".ride_tracker.GetTrackingResponse.routeDetails: object expected");
                m.routeDetails = $root.ride_tracker.RouteDetails.fromObject(d.routeDetails);
            }
            if (d.changeHistory != null) {
                if (typeof d.changeHistory !== "object")
                    throw TypeError(".ride_tracker.GetTrackingResponse.changeHistory: object expected");
                m.changeHistory = $root.ride_tracker.ChangeHistory.fromObject(d.changeHistory);
            }
            switch (d.type) {
            case "RIDE_TYPE_RIDER":
            case 0:
                m.type = 0;
                break;
            case "RIDE_TYPE_SENDER":
            case 1:
                m.type = 1;
                break;
            case "RIDE_TYPE_RECIPIENT":
            case 2:
                m.type = 2;
                break;
            case "RIDE_TYPE_SENDER_AND_RECIPIENT":
            case 3:
                m.type = 3;
                break;
            }
            if (d.company != null) {
                if (typeof d.company !== "object")
                    throw TypeError(".ride_tracker.GetTrackingResponse.company: object expected");
                m.company = $root.ride_tracker.Company.fromObject(d.company);
            }
            switch (d.canceledBy) {
            case "CANCELED_BY_UNSPECIFIED":
            case 0:
                m.canceledBy = 0;
                break;
            case "CANCELED_BY_DRIVER":
            case 1:
                m.canceledBy = 1;
                break;
            case "CANCELED_BY_CC":
            case 2:
                m.canceledBy = 2;
                break;
            case "CANCELED_BY_API":
            case 3:
                m.canceledBy = 3;
                break;
            case "CANCELED_BY_BOOKER":
            case 4:
                m.canceledBy = 4;
                break;
            case "CANCELED_BY_RIDER":
            case 5:
                m.canceledBy = 5;
                break;
            }
            if (d.isMeetAndGreet != null) {
                m.isMeetAndGreet = Boolean(d.isMeetAndGreet);
            }
            if (d.pickupInstructions != null) {
                m.pickupInstructions = String(d.pickupInstructions);
            }
            if (d.isShareRide != null) {
                m.isShareRide = Boolean(d.isShareRide);
            }
            return m;
        };

        /**
         * Creates a plain object from a GetTrackingResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.GetTrackingResponse
         * @static
         * @param {ride_tracker.GetTrackingResponse} m GetTrackingResponse
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTrackingResponse.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.stops = [];
            }
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, false);
                    d.orderId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.orderId = o.longs === String ? "0" : 0;
                d.orderStatus = o.enums === String ? "ORDER_STATUS_UNSPECIFIED" : 0;
                d.rideStartPinCode = "";
                d.country = "";
                d.division = null;
                d.driver = null;
                d.routeDetails = null;
                d.changeHistory = null;
                d.type = o.enums === String ? "RIDE_TYPE_RIDER" : 0;
                d.company = null;
                d.canceledBy = o.enums === String ? "CANCELED_BY_UNSPECIFIED" : 0;
                d.isMeetAndGreet = false;
                d.pickupInstructions = "";
                d.isShareRide = false;
            }
            if (m.orderId != null && m.hasOwnProperty("orderId")) {
                if (typeof m.orderId === "number")
                    d.orderId = o.longs === String ? String(m.orderId) : m.orderId;
                else
                    d.orderId = o.longs === String ? $util.Long.prototype.toString.call(m.orderId) : o.longs === Number ? new $util.LongBits(m.orderId.low >>> 0, m.orderId.high >>> 0).toNumber() : m.orderId;
            }
            if (m.orderStatus != null && m.hasOwnProperty("orderStatus")) {
                d.orderStatus = o.enums === String ? $root.ride_tracker.OrderStatus[m.orderStatus] : m.orderStatus;
            }
            if (m.stops && m.stops.length) {
                d.stops = [];
                for (var j = 0; j < m.stops.length; ++j) {
                    d.stops[j] = $root.ride_tracker.Stop.toObject(m.stops[j], o);
                }
            }
            if (m.rideStartPinCode != null && m.hasOwnProperty("rideStartPinCode")) {
                d.rideStartPinCode = m.rideStartPinCode;
            }
            if (m.country != null && m.hasOwnProperty("country")) {
                d.country = m.country;
            }
            if (m.division != null && m.hasOwnProperty("division")) {
                d.division = $root.ride_tracker.Division.toObject(m.division, o);
            }
            if (m.driver != null && m.hasOwnProperty("driver")) {
                d.driver = $root.ride_tracker.Driver.toObject(m.driver, o);
            }
            if (m.routeDetails != null && m.hasOwnProperty("routeDetails")) {
                d.routeDetails = $root.ride_tracker.RouteDetails.toObject(m.routeDetails, o);
            }
            if (m.changeHistory != null && m.hasOwnProperty("changeHistory")) {
                d.changeHistory = $root.ride_tracker.ChangeHistory.toObject(m.changeHistory, o);
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.ride_tracker.RideType[m.type] : m.type;
            }
            if (m.company != null && m.hasOwnProperty("company")) {
                d.company = $root.ride_tracker.Company.toObject(m.company, o);
            }
            if (m.canceledBy != null && m.hasOwnProperty("canceledBy")) {
                d.canceledBy = o.enums === String ? $root.ride_tracker.CanceledBy[m.canceledBy] : m.canceledBy;
            }
            if (m.isMeetAndGreet != null && m.hasOwnProperty("isMeetAndGreet")) {
                d.isMeetAndGreet = m.isMeetAndGreet;
            }
            if (m.pickupInstructions != null && m.hasOwnProperty("pickupInstructions")) {
                d.pickupInstructions = m.pickupInstructions;
            }
            if (m.isShareRide != null && m.hasOwnProperty("isShareRide")) {
                d.isShareRide = m.isShareRide;
            }
            return d;
        };

        /**
         * Converts this GetTrackingResponse to JSON.
         * @function toJSON
         * @memberof ride_tracker.GetTrackingResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTrackingResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTrackingResponse;
    })();

    /**
     * OrderStatus enum.
     * @name ride_tracker.OrderStatus
     * @enum {number}
     * @property {number} ORDER_STATUS_UNSPECIFIED=0 ORDER_STATUS_UNSPECIFIED value
     * @property {number} ORDER_STATUS_ROUTING=1 ORDER_STATUS_ROUTING value
     * @property {number} ORDER_STATUS_PENDING=2 ORDER_STATUS_PENDING value
     * @property {number} ORDER_STATUS_CONFIRMED=3 ORDER_STATUS_CONFIRMED value
     * @property {number} ORDER_STATUS_CANCELLED=4 ORDER_STATUS_CANCELLED value
     * @property {number} ORDER_STATUS_WAITING=5 ORDER_STATUS_WAITING value
     * @property {number} ORDER_STATUS_DRIVING=6 ORDER_STATUS_DRIVING value
     * @property {number} ORDER_STATUS_COMPLETED=7 ORDER_STATUS_COMPLETED value
     * @property {number} ORDER_STATUS_CARE_REQUESTED=8 ORDER_STATUS_CARE_REQUESTED value
     * @property {number} ORDER_STATUS_REJECTED=9 ORDER_STATUS_REJECTED value
     * @property {number} ORDER_STATUS_ASSIGNED=10 ORDER_STATUS_ASSIGNED value
     * @property {number} ORDER_STATUS_RESERVED=11 ORDER_STATUS_RESERVED value
     * @property {number} ORDER_STATUS_UNRESERVED=12 ORDER_STATUS_UNRESERVED value
     */
    ride_tracker.OrderStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ORDER_STATUS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "ORDER_STATUS_ROUTING"] = 1;
        values[valuesById[2] = "ORDER_STATUS_PENDING"] = 2;
        values[valuesById[3] = "ORDER_STATUS_CONFIRMED"] = 3;
        values[valuesById[4] = "ORDER_STATUS_CANCELLED"] = 4;
        values[valuesById[5] = "ORDER_STATUS_WAITING"] = 5;
        values[valuesById[6] = "ORDER_STATUS_DRIVING"] = 6;
        values[valuesById[7] = "ORDER_STATUS_COMPLETED"] = 7;
        values[valuesById[8] = "ORDER_STATUS_CARE_REQUESTED"] = 8;
        values[valuesById[9] = "ORDER_STATUS_REJECTED"] = 9;
        values[valuesById[10] = "ORDER_STATUS_ASSIGNED"] = 10;
        values[valuesById[11] = "ORDER_STATUS_RESERVED"] = 11;
        values[valuesById[12] = "ORDER_STATUS_UNRESERVED"] = 12;
        return values;
    })();

    ride_tracker.Location = (function() {

        /**
         * Properties of a Location.
         * @memberof ride_tracker
         * @interface ILocation
         * @property {ride_tracker.ICoordinates|null} [coordinates] Location coordinates
         * @property {string|null} [address] Location address
         * @property {string|null} [note] Location note
         */

        /**
         * Constructs a new Location.
         * @memberof ride_tracker
         * @classdesc Represents a Location.
         * @implements ILocation
         * @constructor
         * @param {ride_tracker.ILocation=} [p] Properties to set
         */
        function Location(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Location coordinates.
         * @member {ride_tracker.ICoordinates|null|undefined} coordinates
         * @memberof ride_tracker.Location
         * @instance
         */
        Location.prototype.coordinates = null;

        /**
         * Location address.
         * @member {string} address
         * @memberof ride_tracker.Location
         * @instance
         */
        Location.prototype.address = "";

        /**
         * Location note.
         * @member {string} note
         * @memberof ride_tracker.Location
         * @instance
         */
        Location.prototype.note = "";

        /**
         * Creates a new Location instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Location
         * @static
         * @param {ride_tracker.ILocation=} [properties] Properties to set
         * @returns {ride_tracker.Location} Location instance
         */
        Location.create = function create(properties) {
            return new Location(properties);
        };

        /**
         * Encodes the specified Location message. Does not implicitly {@link ride_tracker.Location.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Location
         * @static
         * @param {ride_tracker.ILocation} m Location message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Location.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coordinates != null && Object.hasOwnProperty.call(m, "coordinates"))
                $root.ride_tracker.Coordinates.encode(m.coordinates, w.uint32(10).fork()).ldelim();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                w.uint32(18).string(m.address);
            if (m.note != null && Object.hasOwnProperty.call(m, "note"))
                w.uint32(26).string(m.note);
            return w;
        };

        /**
         * Decodes a Location message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Location
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Location} Location
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Location.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Location();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coordinates = $root.ride_tracker.Coordinates.decode(r, r.uint32());
                    break;
                case 2:
                    m.address = r.string();
                    break;
                case 3:
                    m.note = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Location message.
         * @function verify
         * @memberof ride_tracker.Location
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Location.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.coordinates != null && m.hasOwnProperty("coordinates")) {
                {
                    var e = $root.ride_tracker.Coordinates.verify(m.coordinates);
                    if (e)
                        return "coordinates." + e;
                }
            }
            if (m.address != null && m.hasOwnProperty("address")) {
                if (!$util.isString(m.address))
                    return "address: string expected";
            }
            if (m.note != null && m.hasOwnProperty("note")) {
                if (!$util.isString(m.note))
                    return "note: string expected";
            }
            return null;
        };

        /**
         * Creates a Location message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Location
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Location} Location
         */
        Location.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Location)
                return d;
            var m = new $root.ride_tracker.Location();
            if (d.coordinates != null) {
                if (typeof d.coordinates !== "object")
                    throw TypeError(".ride_tracker.Location.coordinates: object expected");
                m.coordinates = $root.ride_tracker.Coordinates.fromObject(d.coordinates);
            }
            if (d.address != null) {
                m.address = String(d.address);
            }
            if (d.note != null) {
                m.note = String(d.note);
            }
            return m;
        };

        /**
         * Creates a plain object from a Location message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Location
         * @static
         * @param {ride_tracker.Location} m Location
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Location.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.coordinates = null;
                d.address = "";
                d.note = "";
            }
            if (m.coordinates != null && m.hasOwnProperty("coordinates")) {
                d.coordinates = $root.ride_tracker.Coordinates.toObject(m.coordinates, o);
            }
            if (m.address != null && m.hasOwnProperty("address")) {
                d.address = m.address;
            }
            if (m.note != null && m.hasOwnProperty("note")) {
                d.note = m.note;
            }
            return d;
        };

        /**
         * Converts this Location to JSON.
         * @function toJSON
         * @memberof ride_tracker.Location
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Location.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Location;
    })();

    ride_tracker.Coordinates = (function() {

        /**
         * Properties of a Coordinates.
         * @memberof ride_tracker
         * @interface ICoordinates
         * @property {number|null} [latitude] Coordinates latitude
         * @property {number|null} [longitude] Coordinates longitude
         */

        /**
         * Constructs a new Coordinates.
         * @memberof ride_tracker
         * @classdesc Represents a Coordinates.
         * @implements ICoordinates
         * @constructor
         * @param {ride_tracker.ICoordinates=} [p] Properties to set
         */
        function Coordinates(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Coordinates latitude.
         * @member {number} latitude
         * @memberof ride_tracker.Coordinates
         * @instance
         */
        Coordinates.prototype.latitude = 0;

        /**
         * Coordinates longitude.
         * @member {number} longitude
         * @memberof ride_tracker.Coordinates
         * @instance
         */
        Coordinates.prototype.longitude = 0;

        /**
         * Creates a new Coordinates instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Coordinates
         * @static
         * @param {ride_tracker.ICoordinates=} [properties] Properties to set
         * @returns {ride_tracker.Coordinates} Coordinates instance
         */
        Coordinates.create = function create(properties) {
            return new Coordinates(properties);
        };

        /**
         * Encodes the specified Coordinates message. Does not implicitly {@link ride_tracker.Coordinates.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Coordinates
         * @static
         * @param {ride_tracker.ICoordinates} m Coordinates message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Coordinates.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
                w.uint32(9).double(m.latitude);
            if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
                w.uint32(17).double(m.longitude);
            return w;
        };

        /**
         * Decodes a Coordinates message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Coordinates
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Coordinates} Coordinates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Coordinates.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Coordinates();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.latitude = r.double();
                    break;
                case 2:
                    m.longitude = r.double();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Coordinates message.
         * @function verify
         * @memberof ride_tracker.Coordinates
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Coordinates.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.latitude != null && m.hasOwnProperty("latitude")) {
                if (typeof m.latitude !== "number")
                    return "latitude: number expected";
            }
            if (m.longitude != null && m.hasOwnProperty("longitude")) {
                if (typeof m.longitude !== "number")
                    return "longitude: number expected";
            }
            return null;
        };

        /**
         * Creates a Coordinates message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Coordinates
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Coordinates} Coordinates
         */
        Coordinates.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Coordinates)
                return d;
            var m = new $root.ride_tracker.Coordinates();
            if (d.latitude != null) {
                m.latitude = Number(d.latitude);
            }
            if (d.longitude != null) {
                m.longitude = Number(d.longitude);
            }
            return m;
        };

        /**
         * Creates a plain object from a Coordinates message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Coordinates
         * @static
         * @param {ride_tracker.Coordinates} m Coordinates
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Coordinates.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.latitude = 0;
                d.longitude = 0;
            }
            if (m.latitude != null && m.hasOwnProperty("latitude")) {
                d.latitude = o.json && !isFinite(m.latitude) ? String(m.latitude) : m.latitude;
            }
            if (m.longitude != null && m.hasOwnProperty("longitude")) {
                d.longitude = o.json && !isFinite(m.longitude) ? String(m.longitude) : m.longitude;
            }
            return d;
        };

        /**
         * Converts this Coordinates to JSON.
         * @function toJSON
         * @memberof ride_tracker.Coordinates
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Coordinates.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Coordinates;
    })();

    ride_tracker.Division = (function() {

        /**
         * Properties of a Division.
         * @memberof ride_tracker
         * @interface IDivision
         * @property {string|null} [name] Division name
         * @property {string|null} [picture] Division picture
         * @property {ride_tracker.DivisionType|null} [type] Division type
         */

        /**
         * Constructs a new Division.
         * @memberof ride_tracker
         * @classdesc Represents a Division.
         * @implements IDivision
         * @constructor
         * @param {ride_tracker.IDivision=} [p] Properties to set
         */
        function Division(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Division name.
         * @member {string} name
         * @memberof ride_tracker.Division
         * @instance
         */
        Division.prototype.name = "";

        /**
         * Division picture.
         * @member {string} picture
         * @memberof ride_tracker.Division
         * @instance
         */
        Division.prototype.picture = "";

        /**
         * Division type.
         * @member {ride_tracker.DivisionType} type
         * @memberof ride_tracker.Division
         * @instance
         */
        Division.prototype.type = 0;

        /**
         * Creates a new Division instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Division
         * @static
         * @param {ride_tracker.IDivision=} [properties] Properties to set
         * @returns {ride_tracker.Division} Division instance
         */
        Division.create = function create(properties) {
            return new Division(properties);
        };

        /**
         * Encodes the specified Division message. Does not implicitly {@link ride_tracker.Division.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Division
         * @static
         * @param {ride_tracker.IDivision} m Division message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Division.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.picture != null && Object.hasOwnProperty.call(m, "picture"))
                w.uint32(18).string(m.picture);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(24).int32(m.type);
            return w;
        };

        /**
         * Decodes a Division message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Division
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Division} Division
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Division.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Division();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.picture = r.string();
                    break;
                case 3:
                    m.type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Division message.
         * @function verify
         * @memberof ride_tracker.Division
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Division.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.name != null && m.hasOwnProperty("name")) {
                if (!$util.isString(m.name))
                    return "name: string expected";
            }
            if (m.picture != null && m.hasOwnProperty("picture")) {
                if (!$util.isString(m.picture))
                    return "picture: string expected";
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                    break;
                }
            }
            return null;
        };

        /**
         * Creates a Division message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Division
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Division} Division
         */
        Division.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Division)
                return d;
            var m = new $root.ride_tracker.Division();
            if (d.name != null) {
                m.name = String(d.name);
            }
            if (d.picture != null) {
                m.picture = String(d.picture);
            }
            switch (d.type) {
            case "DIVISION_TYPE_TRANSPORTATION":
            case 0:
                m.type = 0;
                break;
            case "DIVISION_TYPE_DELIVERY":
            case 1:
                m.type = 1;
                break;
            }
            return m;
        };

        /**
         * Creates a plain object from a Division message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Division
         * @static
         * @param {ride_tracker.Division} m Division
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Division.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.name = "";
                d.picture = "";
                d.type = o.enums === String ? "DIVISION_TYPE_TRANSPORTATION" : 0;
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = m.name;
            }
            if (m.picture != null && m.hasOwnProperty("picture")) {
                d.picture = m.picture;
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.ride_tracker.DivisionType[m.type] : m.type;
            }
            return d;
        };

        /**
         * Converts this Division to JSON.
         * @function toJSON
         * @memberof ride_tracker.Division
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Division.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Division;
    })();

    ride_tracker.Driver = (function() {

        /**
         * Properties of a Driver.
         * @memberof ride_tracker
         * @interface IDriver
         * @property {number|null} [id] Driver id
         * @property {string|null} [name] Driver name
         * @property {string|null} [phoneNumber] Driver phoneNumber
         * @property {string|null} [photoUrl] Driver photoUrl
         * @property {number|null} [rating] Driver rating
         * @property {number|null} [ratingCount] Driver ratingCount
         * @property {ride_tracker.ICar|null} [car] Driver car
         * @property {string|null} [fleetName] Driver fleetName
         */

        /**
         * Constructs a new Driver.
         * @memberof ride_tracker
         * @classdesc Represents a Driver.
         * @implements IDriver
         * @constructor
         * @param {ride_tracker.IDriver=} [p] Properties to set
         */
        function Driver(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Driver id.
         * @member {number} id
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Driver name.
         * @member {string} name
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.name = "";

        /**
         * Driver phoneNumber.
         * @member {string} phoneNumber
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.phoneNumber = "";

        /**
         * Driver photoUrl.
         * @member {string} photoUrl
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.photoUrl = "";

        /**
         * Driver rating.
         * @member {number} rating
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.rating = 0;

        /**
         * Driver ratingCount.
         * @member {number} ratingCount
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.ratingCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Driver car.
         * @member {ride_tracker.ICar|null|undefined} car
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.car = null;

        /**
         * Driver fleetName.
         * @member {string} fleetName
         * @memberof ride_tracker.Driver
         * @instance
         */
        Driver.prototype.fleetName = "";

        /**
         * Creates a new Driver instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Driver
         * @static
         * @param {ride_tracker.IDriver=} [properties] Properties to set
         * @returns {ride_tracker.Driver} Driver instance
         */
        Driver.create = function create(properties) {
            return new Driver(properties);
        };

        /**
         * Encodes the specified Driver message. Does not implicitly {@link ride_tracker.Driver.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Driver
         * @static
         * @param {ride_tracker.IDriver} m Driver message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Driver.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(8).int64(m.id);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.phoneNumber != null && Object.hasOwnProperty.call(m, "phoneNumber"))
                w.uint32(26).string(m.phoneNumber);
            if (m.photoUrl != null && Object.hasOwnProperty.call(m, "photoUrl"))
                w.uint32(34).string(m.photoUrl);
            if (m.rating != null && Object.hasOwnProperty.call(m, "rating"))
                w.uint32(45).float(m.rating);
            if (m.ratingCount != null && Object.hasOwnProperty.call(m, "ratingCount"))
                w.uint32(48).int64(m.ratingCount);
            if (m.car != null && Object.hasOwnProperty.call(m, "car"))
                $root.ride_tracker.Car.encode(m.car, w.uint32(58).fork()).ldelim();
            if (m.fleetName != null && Object.hasOwnProperty.call(m, "fleetName"))
                w.uint32(66).string(m.fleetName);
            return w;
        };

        /**
         * Decodes a Driver message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Driver
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Driver} Driver
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Driver.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Driver();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = r.int64();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.phoneNumber = r.string();
                    break;
                case 4:
                    m.photoUrl = r.string();
                    break;
                case 5:
                    m.rating = r.float();
                    break;
                case 6:
                    m.ratingCount = r.int64();
                    break;
                case 7:
                    m.car = $root.ride_tracker.Car.decode(r, r.uint32());
                    break;
                case 8:
                    m.fleetName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Driver message.
         * @function verify
         * @memberof ride_tracker.Driver
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Driver.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.id != null && m.hasOwnProperty("id")) {
                if (!$util.isInteger(m.id) && !(m.id && $util.isInteger(m.id.low) && $util.isInteger(m.id.high)))
                    return "id: integer|Long expected";
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                if (!$util.isString(m.name))
                    return "name: string expected";
            }
            if (m.phoneNumber != null && m.hasOwnProperty("phoneNumber")) {
                if (!$util.isString(m.phoneNumber))
                    return "phoneNumber: string expected";
            }
            if (m.photoUrl != null && m.hasOwnProperty("photoUrl")) {
                if (!$util.isString(m.photoUrl))
                    return "photoUrl: string expected";
            }
            if (m.rating != null && m.hasOwnProperty("rating")) {
                if (typeof m.rating !== "number")
                    return "rating: number expected";
            }
            if (m.ratingCount != null && m.hasOwnProperty("ratingCount")) {
                if (!$util.isInteger(m.ratingCount) && !(m.ratingCount && $util.isInteger(m.ratingCount.low) && $util.isInteger(m.ratingCount.high)))
                    return "ratingCount: integer|Long expected";
            }
            if (m.car != null && m.hasOwnProperty("car")) {
                {
                    var e = $root.ride_tracker.Car.verify(m.car);
                    if (e)
                        return "car." + e;
                }
            }
            if (m.fleetName != null && m.hasOwnProperty("fleetName")) {
                if (!$util.isString(m.fleetName))
                    return "fleetName: string expected";
            }
            return null;
        };

        /**
         * Creates a Driver message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Driver
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Driver} Driver
         */
        Driver.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Driver)
                return d;
            var m = new $root.ride_tracker.Driver();
            if (d.id != null) {
                if ($util.Long)
                    (m.id = $util.Long.fromValue(d.id)).unsigned = false;
                else if (typeof d.id === "string")
                    m.id = parseInt(d.id, 10);
                else if (typeof d.id === "number")
                    m.id = d.id;
                else if (typeof d.id === "object")
                    m.id = new $util.LongBits(d.id.low >>> 0, d.id.high >>> 0).toNumber();
            }
            if (d.name != null) {
                m.name = String(d.name);
            }
            if (d.phoneNumber != null) {
                m.phoneNumber = String(d.phoneNumber);
            }
            if (d.photoUrl != null) {
                m.photoUrl = String(d.photoUrl);
            }
            if (d.rating != null) {
                m.rating = Number(d.rating);
            }
            if (d.ratingCount != null) {
                if ($util.Long)
                    (m.ratingCount = $util.Long.fromValue(d.ratingCount)).unsigned = false;
                else if (typeof d.ratingCount === "string")
                    m.ratingCount = parseInt(d.ratingCount, 10);
                else if (typeof d.ratingCount === "number")
                    m.ratingCount = d.ratingCount;
                else if (typeof d.ratingCount === "object")
                    m.ratingCount = new $util.LongBits(d.ratingCount.low >>> 0, d.ratingCount.high >>> 0).toNumber();
            }
            if (d.car != null) {
                if (typeof d.car !== "object")
                    throw TypeError(".ride_tracker.Driver.car: object expected");
                m.car = $root.ride_tracker.Car.fromObject(d.car);
            }
            if (d.fleetName != null) {
                m.fleetName = String(d.fleetName);
            }
            return m;
        };

        /**
         * Creates a plain object from a Driver message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Driver
         * @static
         * @param {ride_tracker.Driver} m Driver
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Driver.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, false);
                    d.id = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.id = o.longs === String ? "0" : 0;
                d.name = "";
                d.phoneNumber = "";
                d.photoUrl = "";
                d.rating = 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, false);
                    d.ratingCount = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.ratingCount = o.longs === String ? "0" : 0;
                d.car = null;
                d.fleetName = "";
            }
            if (m.id != null && m.hasOwnProperty("id")) {
                if (typeof m.id === "number")
                    d.id = o.longs === String ? String(m.id) : m.id;
                else
                    d.id = o.longs === String ? $util.Long.prototype.toString.call(m.id) : o.longs === Number ? new $util.LongBits(m.id.low >>> 0, m.id.high >>> 0).toNumber() : m.id;
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = m.name;
            }
            if (m.phoneNumber != null && m.hasOwnProperty("phoneNumber")) {
                d.phoneNumber = m.phoneNumber;
            }
            if (m.photoUrl != null && m.hasOwnProperty("photoUrl")) {
                d.photoUrl = m.photoUrl;
            }
            if (m.rating != null && m.hasOwnProperty("rating")) {
                d.rating = o.json && !isFinite(m.rating) ? String(m.rating) : m.rating;
            }
            if (m.ratingCount != null && m.hasOwnProperty("ratingCount")) {
                if (typeof m.ratingCount === "number")
                    d.ratingCount = o.longs === String ? String(m.ratingCount) : m.ratingCount;
                else
                    d.ratingCount = o.longs === String ? $util.Long.prototype.toString.call(m.ratingCount) : o.longs === Number ? new $util.LongBits(m.ratingCount.low >>> 0, m.ratingCount.high >>> 0).toNumber() : m.ratingCount;
            }
            if (m.car != null && m.hasOwnProperty("car")) {
                d.car = $root.ride_tracker.Car.toObject(m.car, o);
            }
            if (m.fleetName != null && m.hasOwnProperty("fleetName")) {
                d.fleetName = m.fleetName;
            }
            return d;
        };

        /**
         * Converts this Driver to JSON.
         * @function toJSON
         * @memberof ride_tracker.Driver
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Driver.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Driver;
    })();

    ride_tracker.Car = (function() {

        /**
         * Properties of a Car.
         * @memberof ride_tracker
         * @interface ICar
         * @property {string|null} [plateNumber] Car plateNumber
         * @property {string|null} [type] Car type
         * @property {string|null} [model] Car model
         * @property {string|null} [color] Car color
         */

        /**
         * Constructs a new Car.
         * @memberof ride_tracker
         * @classdesc Represents a Car.
         * @implements ICar
         * @constructor
         * @param {ride_tracker.ICar=} [p] Properties to set
         */
        function Car(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Car plateNumber.
         * @member {string} plateNumber
         * @memberof ride_tracker.Car
         * @instance
         */
        Car.prototype.plateNumber = "";

        /**
         * Car type.
         * @member {string} type
         * @memberof ride_tracker.Car
         * @instance
         */
        Car.prototype.type = "";

        /**
         * Car model.
         * @member {string} model
         * @memberof ride_tracker.Car
         * @instance
         */
        Car.prototype.model = "";

        /**
         * Car color.
         * @member {string} color
         * @memberof ride_tracker.Car
         * @instance
         */
        Car.prototype.color = "";

        /**
         * Creates a new Car instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Car
         * @static
         * @param {ride_tracker.ICar=} [properties] Properties to set
         * @returns {ride_tracker.Car} Car instance
         */
        Car.create = function create(properties) {
            return new Car(properties);
        };

        /**
         * Encodes the specified Car message. Does not implicitly {@link ride_tracker.Car.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Car
         * @static
         * @param {ride_tracker.ICar} m Car message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Car.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.plateNumber != null && Object.hasOwnProperty.call(m, "plateNumber"))
                w.uint32(10).string(m.plateNumber);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.model != null && Object.hasOwnProperty.call(m, "model"))
                w.uint32(26).string(m.model);
            if (m.color != null && Object.hasOwnProperty.call(m, "color"))
                w.uint32(34).string(m.color);
            return w;
        };

        /**
         * Decodes a Car message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Car
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Car} Car
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Car.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Car();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.plateNumber = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.model = r.string();
                    break;
                case 4:
                    m.color = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Car message.
         * @function verify
         * @memberof ride_tracker.Car
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Car.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.plateNumber != null && m.hasOwnProperty("plateNumber")) {
                if (!$util.isString(m.plateNumber))
                    return "plateNumber: string expected";
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                if (!$util.isString(m.type))
                    return "type: string expected";
            }
            if (m.model != null && m.hasOwnProperty("model")) {
                if (!$util.isString(m.model))
                    return "model: string expected";
            }
            if (m.color != null && m.hasOwnProperty("color")) {
                if (!$util.isString(m.color))
                    return "color: string expected";
            }
            return null;
        };

        /**
         * Creates a Car message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Car
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Car} Car
         */
        Car.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Car)
                return d;
            var m = new $root.ride_tracker.Car();
            if (d.plateNumber != null) {
                m.plateNumber = String(d.plateNumber);
            }
            if (d.type != null) {
                m.type = String(d.type);
            }
            if (d.model != null) {
                m.model = String(d.model);
            }
            if (d.color != null) {
                m.color = String(d.color);
            }
            return m;
        };

        /**
         * Creates a plain object from a Car message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Car
         * @static
         * @param {ride_tracker.Car} m Car
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Car.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.plateNumber = "";
                d.type = "";
                d.model = "";
                d.color = "";
            }
            if (m.plateNumber != null && m.hasOwnProperty("plateNumber")) {
                d.plateNumber = m.plateNumber;
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = m.type;
            }
            if (m.model != null && m.hasOwnProperty("model")) {
                d.model = m.model;
            }
            if (m.color != null && m.hasOwnProperty("color")) {
                d.color = m.color;
            }
            return d;
        };

        /**
         * Converts this Car to JSON.
         * @function toJSON
         * @memberof ride_tracker.Car
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Car.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Car;
    })();

    ride_tracker.RouteDetails = (function() {

        /**
         * Properties of a RouteDetails.
         * @memberof ride_tracker
         * @interface IRouteDetails
         * @property {boolean|null} [isUntrackble] RouteDetails isUntrackble
         * @property {ride_tracker.ICoordinates|null} [driverLocation] RouteDetails driverLocation
         * @property {ride_tracker.IETA|null} [eta] RouteDetails eta
         * @property {number|null} [distance] RouteDetails distance
         * @property {string|null} [polyline] RouteDetails polyline
         * @property {number|null} [bearing] RouteDetails bearing
         */

        /**
         * Constructs a new RouteDetails.
         * @memberof ride_tracker
         * @classdesc Represents a RouteDetails.
         * @implements IRouteDetails
         * @constructor
         * @param {ride_tracker.IRouteDetails=} [p] Properties to set
         */
        function RouteDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RouteDetails isUntrackble.
         * @member {boolean} isUntrackble
         * @memberof ride_tracker.RouteDetails
         * @instance
         */
        RouteDetails.prototype.isUntrackble = false;

        /**
         * RouteDetails driverLocation.
         * @member {ride_tracker.ICoordinates|null|undefined} driverLocation
         * @memberof ride_tracker.RouteDetails
         * @instance
         */
        RouteDetails.prototype.driverLocation = null;

        /**
         * RouteDetails eta.
         * @member {ride_tracker.IETA|null|undefined} eta
         * @memberof ride_tracker.RouteDetails
         * @instance
         */
        RouteDetails.prototype.eta = null;

        /**
         * RouteDetails distance.
         * @member {number} distance
         * @memberof ride_tracker.RouteDetails
         * @instance
         */
        RouteDetails.prototype.distance = 0;

        /**
         * RouteDetails polyline.
         * @member {string} polyline
         * @memberof ride_tracker.RouteDetails
         * @instance
         */
        RouteDetails.prototype.polyline = "";

        /**
         * RouteDetails bearing.
         * @member {number} bearing
         * @memberof ride_tracker.RouteDetails
         * @instance
         */
        RouteDetails.prototype.bearing = 0;

        /**
         * Creates a new RouteDetails instance using the specified properties.
         * @function create
         * @memberof ride_tracker.RouteDetails
         * @static
         * @param {ride_tracker.IRouteDetails=} [properties] Properties to set
         * @returns {ride_tracker.RouteDetails} RouteDetails instance
         */
        RouteDetails.create = function create(properties) {
            return new RouteDetails(properties);
        };

        /**
         * Encodes the specified RouteDetails message. Does not implicitly {@link ride_tracker.RouteDetails.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.RouteDetails
         * @static
         * @param {ride_tracker.IRouteDetails} m RouteDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RouteDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.isUntrackble != null && Object.hasOwnProperty.call(m, "isUntrackble"))
                w.uint32(8).bool(m.isUntrackble);
            if (m.driverLocation != null && Object.hasOwnProperty.call(m, "driverLocation"))
                $root.ride_tracker.Coordinates.encode(m.driverLocation, w.uint32(18).fork()).ldelim();
            if (m.eta != null && Object.hasOwnProperty.call(m, "eta"))
                $root.ride_tracker.ETA.encode(m.eta, w.uint32(26).fork()).ldelim();
            if (m.distance != null && Object.hasOwnProperty.call(m, "distance"))
                w.uint32(33).double(m.distance);
            if (m.polyline != null && Object.hasOwnProperty.call(m, "polyline"))
                w.uint32(42).string(m.polyline);
            if (m.bearing != null && Object.hasOwnProperty.call(m, "bearing"))
                w.uint32(53).float(m.bearing);
            return w;
        };

        /**
         * Decodes a RouteDetails message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.RouteDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.RouteDetails} RouteDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RouteDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.RouteDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.isUntrackble = r.bool();
                    break;
                case 2:
                    m.driverLocation = $root.ride_tracker.Coordinates.decode(r, r.uint32());
                    break;
                case 3:
                    m.eta = $root.ride_tracker.ETA.decode(r, r.uint32());
                    break;
                case 4:
                    m.distance = r.double();
                    break;
                case 5:
                    m.polyline = r.string();
                    break;
                case 6:
                    m.bearing = r.float();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a RouteDetails message.
         * @function verify
         * @memberof ride_tracker.RouteDetails
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RouteDetails.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.isUntrackble != null && m.hasOwnProperty("isUntrackble")) {
                if (typeof m.isUntrackble !== "boolean")
                    return "isUntrackble: boolean expected";
            }
            if (m.driverLocation != null && m.hasOwnProperty("driverLocation")) {
                {
                    var e = $root.ride_tracker.Coordinates.verify(m.driverLocation);
                    if (e)
                        return "driverLocation." + e;
                }
            }
            if (m.eta != null && m.hasOwnProperty("eta")) {
                {
                    var e = $root.ride_tracker.ETA.verify(m.eta);
                    if (e)
                        return "eta." + e;
                }
            }
            if (m.distance != null && m.hasOwnProperty("distance")) {
                if (typeof m.distance !== "number")
                    return "distance: number expected";
            }
            if (m.polyline != null && m.hasOwnProperty("polyline")) {
                if (!$util.isString(m.polyline))
                    return "polyline: string expected";
            }
            if (m.bearing != null && m.hasOwnProperty("bearing")) {
                if (typeof m.bearing !== "number")
                    return "bearing: number expected";
            }
            return null;
        };

        /**
         * Creates a RouteDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.RouteDetails
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.RouteDetails} RouteDetails
         */
        RouteDetails.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.RouteDetails)
                return d;
            var m = new $root.ride_tracker.RouteDetails();
            if (d.isUntrackble != null) {
                m.isUntrackble = Boolean(d.isUntrackble);
            }
            if (d.driverLocation != null) {
                if (typeof d.driverLocation !== "object")
                    throw TypeError(".ride_tracker.RouteDetails.driverLocation: object expected");
                m.driverLocation = $root.ride_tracker.Coordinates.fromObject(d.driverLocation);
            }
            if (d.eta != null) {
                if (typeof d.eta !== "object")
                    throw TypeError(".ride_tracker.RouteDetails.eta: object expected");
                m.eta = $root.ride_tracker.ETA.fromObject(d.eta);
            }
            if (d.distance != null) {
                m.distance = Number(d.distance);
            }
            if (d.polyline != null) {
                m.polyline = String(d.polyline);
            }
            if (d.bearing != null) {
                m.bearing = Number(d.bearing);
            }
            return m;
        };

        /**
         * Creates a plain object from a RouteDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.RouteDetails
         * @static
         * @param {ride_tracker.RouteDetails} m RouteDetails
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RouteDetails.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.isUntrackble = false;
                d.driverLocation = null;
                d.eta = null;
                d.distance = 0;
                d.polyline = "";
                d.bearing = 0;
            }
            if (m.isUntrackble != null && m.hasOwnProperty("isUntrackble")) {
                d.isUntrackble = m.isUntrackble;
            }
            if (m.driverLocation != null && m.hasOwnProperty("driverLocation")) {
                d.driverLocation = $root.ride_tracker.Coordinates.toObject(m.driverLocation, o);
            }
            if (m.eta != null && m.hasOwnProperty("eta")) {
                d.eta = $root.ride_tracker.ETA.toObject(m.eta, o);
            }
            if (m.distance != null && m.hasOwnProperty("distance")) {
                d.distance = o.json && !isFinite(m.distance) ? String(m.distance) : m.distance;
            }
            if (m.polyline != null && m.hasOwnProperty("polyline")) {
                d.polyline = m.polyline;
            }
            if (m.bearing != null && m.hasOwnProperty("bearing")) {
                d.bearing = o.json && !isFinite(m.bearing) ? String(m.bearing) : m.bearing;
            }
            return d;
        };

        /**
         * Converts this RouteDetails to JSON.
         * @function toJSON
         * @memberof ride_tracker.RouteDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RouteDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RouteDetails;
    })();

    ride_tracker.ChangeHistory = (function() {

        /**
         * Properties of a ChangeHistory.
         * @memberof ride_tracker
         * @interface IChangeHistory
         * @property {google.protobuf.ITimestamp|null} [scheduledAt] ChangeHistory scheduledAt
         * @property {google.protobuf.ITimestamp|null} [completedAt] ChangeHistory completedAt
         */

        /**
         * Constructs a new ChangeHistory.
         * @memberof ride_tracker
         * @classdesc Represents a ChangeHistory.
         * @implements IChangeHistory
         * @constructor
         * @param {ride_tracker.IChangeHistory=} [p] Properties to set
         */
        function ChangeHistory(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ChangeHistory scheduledAt.
         * @member {google.protobuf.ITimestamp|null|undefined} scheduledAt
         * @memberof ride_tracker.ChangeHistory
         * @instance
         */
        ChangeHistory.prototype.scheduledAt = null;

        /**
         * ChangeHistory completedAt.
         * @member {google.protobuf.ITimestamp|null|undefined} completedAt
         * @memberof ride_tracker.ChangeHistory
         * @instance
         */
        ChangeHistory.prototype.completedAt = null;

        /**
         * Creates a new ChangeHistory instance using the specified properties.
         * @function create
         * @memberof ride_tracker.ChangeHistory
         * @static
         * @param {ride_tracker.IChangeHistory=} [properties] Properties to set
         * @returns {ride_tracker.ChangeHistory} ChangeHistory instance
         */
        ChangeHistory.create = function create(properties) {
            return new ChangeHistory(properties);
        };

        /**
         * Encodes the specified ChangeHistory message. Does not implicitly {@link ride_tracker.ChangeHistory.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.ChangeHistory
         * @static
         * @param {ride_tracker.IChangeHistory} m ChangeHistory message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChangeHistory.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.scheduledAt != null && Object.hasOwnProperty.call(m, "scheduledAt"))
                $root.google.protobuf.Timestamp.encode(m.scheduledAt, w.uint32(10).fork()).ldelim();
            if (m.completedAt != null && Object.hasOwnProperty.call(m, "completedAt"))
                $root.google.protobuf.Timestamp.encode(m.completedAt, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ChangeHistory message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.ChangeHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.ChangeHistory} ChangeHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChangeHistory.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.ChangeHistory();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.scheduledAt = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.completedAt = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a ChangeHistory message.
         * @function verify
         * @memberof ride_tracker.ChangeHistory
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChangeHistory.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.scheduledAt != null && m.hasOwnProperty("scheduledAt")) {
                {
                    var e = $root.google.protobuf.Timestamp.verify(m.scheduledAt);
                    if (e)
                        return "scheduledAt." + e;
                }
            }
            if (m.completedAt != null && m.hasOwnProperty("completedAt")) {
                {
                    var e = $root.google.protobuf.Timestamp.verify(m.completedAt);
                    if (e)
                        return "completedAt." + e;
                }
            }
            return null;
        };

        /**
         * Creates a ChangeHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.ChangeHistory
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.ChangeHistory} ChangeHistory
         */
        ChangeHistory.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.ChangeHistory)
                return d;
            var m = new $root.ride_tracker.ChangeHistory();
            if (d.scheduledAt != null) {
                if (typeof d.scheduledAt !== "object")
                    throw TypeError(".ride_tracker.ChangeHistory.scheduledAt: object expected");
                m.scheduledAt = $root.google.protobuf.Timestamp.fromObject(d.scheduledAt);
            }
            if (d.completedAt != null) {
                if (typeof d.completedAt !== "object")
                    throw TypeError(".ride_tracker.ChangeHistory.completedAt: object expected");
                m.completedAt = $root.google.protobuf.Timestamp.fromObject(d.completedAt);
            }
            return m;
        };

        /**
         * Creates a plain object from a ChangeHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.ChangeHistory
         * @static
         * @param {ride_tracker.ChangeHistory} m ChangeHistory
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChangeHistory.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.scheduledAt = null;
                d.completedAt = null;
            }
            if (m.scheduledAt != null && m.hasOwnProperty("scheduledAt")) {
                d.scheduledAt = $root.google.protobuf.Timestamp.toObject(m.scheduledAt, o);
            }
            if (m.completedAt != null && m.hasOwnProperty("completedAt")) {
                d.completedAt = $root.google.protobuf.Timestamp.toObject(m.completedAt, o);
            }
            return d;
        };

        /**
         * Converts this ChangeHistory to JSON.
         * @function toJSON
         * @memberof ride_tracker.ChangeHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChangeHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChangeHistory;
    })();

    ride_tracker.PushEventRequest = (function() {

        /**
         * Properties of a PushEventRequest.
         * @memberof ride_tracker
         * @interface IPushEventRequest
         * @property {string|null} [trackingId] PushEventRequest trackingId
         * @property {ride_tracker.EventType|null} [type] PushEventRequest type
         */

        /**
         * Constructs a new PushEventRequest.
         * @memberof ride_tracker
         * @classdesc Represents a PushEventRequest.
         * @implements IPushEventRequest
         * @constructor
         * @param {ride_tracker.IPushEventRequest=} [p] Properties to set
         */
        function PushEventRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PushEventRequest trackingId.
         * @member {string} trackingId
         * @memberof ride_tracker.PushEventRequest
         * @instance
         */
        PushEventRequest.prototype.trackingId = "";

        /**
         * PushEventRequest type.
         * @member {ride_tracker.EventType} type
         * @memberof ride_tracker.PushEventRequest
         * @instance
         */
        PushEventRequest.prototype.type = 0;

        /**
         * Creates a new PushEventRequest instance using the specified properties.
         * @function create
         * @memberof ride_tracker.PushEventRequest
         * @static
         * @param {ride_tracker.IPushEventRequest=} [properties] Properties to set
         * @returns {ride_tracker.PushEventRequest} PushEventRequest instance
         */
        PushEventRequest.create = function create(properties) {
            return new PushEventRequest(properties);
        };

        /**
         * Encodes the specified PushEventRequest message. Does not implicitly {@link ride_tracker.PushEventRequest.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.PushEventRequest
         * @static
         * @param {ride_tracker.IPushEventRequest} m PushEventRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PushEventRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.trackingId != null && Object.hasOwnProperty.call(m, "trackingId"))
                w.uint32(10).string(m.trackingId);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            return w;
        };

        /**
         * Decodes a PushEventRequest message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.PushEventRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.PushEventRequest} PushEventRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PushEventRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.PushEventRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.trackingId = r.string();
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a PushEventRequest message.
         * @function verify
         * @memberof ride_tracker.PushEventRequest
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PushEventRequest.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.trackingId != null && m.hasOwnProperty("trackingId")) {
                if (!$util.isString(m.trackingId))
                    return "trackingId: string expected";
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            }
            return null;
        };

        /**
         * Creates a PushEventRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.PushEventRequest
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.PushEventRequest} PushEventRequest
         */
        PushEventRequest.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.PushEventRequest)
                return d;
            var m = new $root.ride_tracker.PushEventRequest();
            if (d.trackingId != null) {
                m.trackingId = String(d.trackingId);
            }
            switch (d.type) {
            case "EVENT_TYPE_UNSPECIFIED":
            case 0:
                m.type = 0;
                break;
            case "EVENT_TYPE_LINK_OPENED":
            case 1:
                m.type = 1;
                break;
            case "EVENT_TYPE_PAGE_LOADED":
            case 2:
                m.type = 2;
                break;
            case "EVENT_TYPE_USER_AGREEMENT_ACCEPTED":
            case 3:
                m.type = 3;
                break;
            case "EVENT_TYPE_USER_AGREEMENT_REJECTED":
            case 4:
                m.type = 4;
                break;
            case "EVENT_TYPE_CALL_TO_DRIVER":
            case 5:
                m.type = 5;
                break;
            case "EVENT_TYPE_CHAT_WITH_CEXP":
            case 6:
                m.type = 6;
                break;
            }
            return m;
        };

        /**
         * Creates a plain object from a PushEventRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.PushEventRequest
         * @static
         * @param {ride_tracker.PushEventRequest} m PushEventRequest
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PushEventRequest.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.trackingId = "";
                d.type = o.enums === String ? "EVENT_TYPE_UNSPECIFIED" : 0;
            }
            if (m.trackingId != null && m.hasOwnProperty("trackingId")) {
                d.trackingId = m.trackingId;
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.ride_tracker.EventType[m.type] : m.type;
            }
            return d;
        };

        /**
         * Converts this PushEventRequest to JSON.
         * @function toJSON
         * @memberof ride_tracker.PushEventRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PushEventRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PushEventRequest;
    })();

    /**
     * EventType enum.
     * @name ride_tracker.EventType
     * @enum {number}
     * @property {number} EVENT_TYPE_UNSPECIFIED=0 EVENT_TYPE_UNSPECIFIED value
     * @property {number} EVENT_TYPE_LINK_OPENED=1 EVENT_TYPE_LINK_OPENED value
     * @property {number} EVENT_TYPE_PAGE_LOADED=2 EVENT_TYPE_PAGE_LOADED value
     * @property {number} EVENT_TYPE_USER_AGREEMENT_ACCEPTED=3 EVENT_TYPE_USER_AGREEMENT_ACCEPTED value
     * @property {number} EVENT_TYPE_USER_AGREEMENT_REJECTED=4 EVENT_TYPE_USER_AGREEMENT_REJECTED value
     * @property {number} EVENT_TYPE_CALL_TO_DRIVER=5 EVENT_TYPE_CALL_TO_DRIVER value
     * @property {number} EVENT_TYPE_CHAT_WITH_CEXP=6 EVENT_TYPE_CHAT_WITH_CEXP value
     */
    ride_tracker.EventType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EVENT_TYPE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "EVENT_TYPE_LINK_OPENED"] = 1;
        values[valuesById[2] = "EVENT_TYPE_PAGE_LOADED"] = 2;
        values[valuesById[3] = "EVENT_TYPE_USER_AGREEMENT_ACCEPTED"] = 3;
        values[valuesById[4] = "EVENT_TYPE_USER_AGREEMENT_REJECTED"] = 4;
        values[valuesById[5] = "EVENT_TYPE_CALL_TO_DRIVER"] = 5;
        values[valuesById[6] = "EVENT_TYPE_CHAT_WITH_CEXP"] = 6;
        return values;
    })();

    ride_tracker.Stop = (function() {

        /**
         * Properties of a Stop.
         * @memberof ride_tracker
         * @interface IStop
         * @property {ride_tracker.ILocation|null} [location] Stop location
         * @property {ride_tracker.LocationType|null} [type] Stop type
         * @property {Array.<ride_tracker.IStopAction>|null} [actions] Stop actions
         */

        /**
         * Constructs a new Stop.
         * @memberof ride_tracker
         * @classdesc Represents a Stop.
         * @implements IStop
         * @constructor
         * @param {ride_tracker.IStop=} [p] Properties to set
         */
        function Stop(p) {
            this.actions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Stop location.
         * @member {ride_tracker.ILocation|null|undefined} location
         * @memberof ride_tracker.Stop
         * @instance
         */
        Stop.prototype.location = null;

        /**
         * Stop type.
         * @member {ride_tracker.LocationType} type
         * @memberof ride_tracker.Stop
         * @instance
         */
        Stop.prototype.type = 0;

        /**
         * Stop actions.
         * @member {Array.<ride_tracker.IStopAction>} actions
         * @memberof ride_tracker.Stop
         * @instance
         */
        Stop.prototype.actions = $util.emptyArray;

        /**
         * Creates a new Stop instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Stop
         * @static
         * @param {ride_tracker.IStop=} [properties] Properties to set
         * @returns {ride_tracker.Stop} Stop instance
         */
        Stop.create = function create(properties) {
            return new Stop(properties);
        };

        /**
         * Encodes the specified Stop message. Does not implicitly {@link ride_tracker.Stop.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Stop
         * @static
         * @param {ride_tracker.IStop} m Stop message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Stop.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.location != null && Object.hasOwnProperty.call(m, "location"))
                $root.ride_tracker.Location.encode(m.location, w.uint32(10).fork()).ldelim();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            if (m.actions != null && m.actions.length) {
                for (var i = 0; i < m.actions.length; ++i)
                    $root.ride_tracker.StopAction.encode(m.actions[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a Stop message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Stop
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Stop} Stop
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Stop.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Stop();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.location = $root.ride_tracker.Location.decode(r, r.uint32());
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                case 3:
                    if (!(m.actions && m.actions.length))
                        m.actions = [];
                    m.actions.push($root.ride_tracker.StopAction.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Stop message.
         * @function verify
         * @memberof ride_tracker.Stop
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Stop.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.location != null && m.hasOwnProperty("location")) {
                {
                    var e = $root.ride_tracker.Location.verify(m.location);
                    if (e)
                        return "location." + e;
                }
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            }
            if (m.actions != null && m.hasOwnProperty("actions")) {
                if (!Array.isArray(m.actions))
                    return "actions: array expected";
                for (var i = 0; i < m.actions.length; ++i) {
                    {
                        var e = $root.ride_tracker.StopAction.verify(m.actions[i]);
                        if (e)
                            return "actions." + e;
                    }
                }
            }
            return null;
        };

        /**
         * Creates a Stop message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Stop
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Stop} Stop
         */
        Stop.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Stop)
                return d;
            var m = new $root.ride_tracker.Stop();
            if (d.location != null) {
                if (typeof d.location !== "object")
                    throw TypeError(".ride_tracker.Stop.location: object expected");
                m.location = $root.ride_tracker.Location.fromObject(d.location);
            }
            switch (d.type) {
            case "LOCATION_TYPE_ORIGIN":
            case 0:
                m.type = 0;
                break;
            case "LOCATION_TYPE_DESTINATION":
            case 1:
                m.type = 1;
                break;
            case "LOCATION_TYPE_ONGOING":
            case 2:
                m.type = 2;
                break;
            }
            if (d.actions) {
                if (!Array.isArray(d.actions))
                    throw TypeError(".ride_tracker.Stop.actions: array expected");
                m.actions = [];
                for (var i = 0; i < d.actions.length; ++i) {
                    if (typeof d.actions[i] !== "object")
                        throw TypeError(".ride_tracker.Stop.actions: object expected");
                    m.actions[i] = $root.ride_tracker.StopAction.fromObject(d.actions[i]);
                }
            }
            return m;
        };

        /**
         * Creates a plain object from a Stop message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Stop
         * @static
         * @param {ride_tracker.Stop} m Stop
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Stop.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.actions = [];
            }
            if (o.defaults) {
                d.location = null;
                d.type = o.enums === String ? "LOCATION_TYPE_ORIGIN" : 0;
            }
            if (m.location != null && m.hasOwnProperty("location")) {
                d.location = $root.ride_tracker.Location.toObject(m.location, o);
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.ride_tracker.LocationType[m.type] : m.type;
            }
            if (m.actions && m.actions.length) {
                d.actions = [];
                for (var j = 0; j < m.actions.length; ++j) {
                    d.actions[j] = $root.ride_tracker.StopAction.toObject(m.actions[j], o);
                }
            }
            return d;
        };

        /**
         * Converts this Stop to JSON.
         * @function toJSON
         * @memberof ride_tracker.Stop
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Stop.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Stop;
    })();

    ride_tracker.StopAction = (function() {

        /**
         * Properties of a StopAction.
         * @memberof ride_tracker
         * @interface IStopAction
         * @property {ride_tracker.StopActionType|null} [type] StopAction type
         * @property {ride_tracker.IParcel|null} [parcel] StopAction parcel
         */

        /**
         * Constructs a new StopAction.
         * @memberof ride_tracker
         * @classdesc Represents a StopAction.
         * @implements IStopAction
         * @constructor
         * @param {ride_tracker.IStopAction=} [p] Properties to set
         */
        function StopAction(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StopAction type.
         * @member {ride_tracker.StopActionType} type
         * @memberof ride_tracker.StopAction
         * @instance
         */
        StopAction.prototype.type = 0;

        /**
         * StopAction parcel.
         * @member {ride_tracker.IParcel|null|undefined} parcel
         * @memberof ride_tracker.StopAction
         * @instance
         */
        StopAction.prototype.parcel = null;

        /**
         * Creates a new StopAction instance using the specified properties.
         * @function create
         * @memberof ride_tracker.StopAction
         * @static
         * @param {ride_tracker.IStopAction=} [properties] Properties to set
         * @returns {ride_tracker.StopAction} StopAction instance
         */
        StopAction.create = function create(properties) {
            return new StopAction(properties);
        };

        /**
         * Encodes the specified StopAction message. Does not implicitly {@link ride_tracker.StopAction.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.StopAction
         * @static
         * @param {ride_tracker.IStopAction} m StopAction message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StopAction.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(8).int32(m.type);
            if (m.parcel != null && Object.hasOwnProperty.call(m, "parcel"))
                $root.ride_tracker.Parcel.encode(m.parcel, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a StopAction message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.StopAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.StopAction} StopAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StopAction.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.StopAction();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.int32();
                    break;
                case 2:
                    m.parcel = $root.ride_tracker.Parcel.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a StopAction message.
         * @function verify
         * @memberof ride_tracker.StopAction
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StopAction.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            }
            if (m.parcel != null && m.hasOwnProperty("parcel")) {
                {
                    var e = $root.ride_tracker.Parcel.verify(m.parcel);
                    if (e)
                        return "parcel." + e;
                }
            }
            return null;
        };

        /**
         * Creates a StopAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.StopAction
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.StopAction} StopAction
         */
        StopAction.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.StopAction)
                return d;
            var m = new $root.ride_tracker.StopAction();
            switch (d.type) {
            case "STOP_ACTION_PICKUP":
            case 0:
                m.type = 0;
                break;
            case "STOP_ACTION_DROP_OFF":
            case 1:
                m.type = 1;
                break;
            case "STOP_ACTION_STOP_BY":
            case 2:
                m.type = 2;
                break;
            }
            if (d.parcel != null) {
                if (typeof d.parcel !== "object")
                    throw TypeError(".ride_tracker.StopAction.parcel: object expected");
                m.parcel = $root.ride_tracker.Parcel.fromObject(d.parcel);
            }
            return m;
        };

        /**
         * Creates a plain object from a StopAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.StopAction
         * @static
         * @param {ride_tracker.StopAction} m StopAction
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StopAction.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.type = o.enums === String ? "STOP_ACTION_PICKUP" : 0;
                d.parcel = null;
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.ride_tracker.StopActionType[m.type] : m.type;
            }
            if (m.parcel != null && m.hasOwnProperty("parcel")) {
                d.parcel = $root.ride_tracker.Parcel.toObject(m.parcel, o);
            }
            return d;
        };

        /**
         * Converts this StopAction to JSON.
         * @function toJSON
         * @memberof ride_tracker.StopAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StopAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StopAction;
    })();

    /**
     * LocationType enum.
     * @name ride_tracker.LocationType
     * @enum {number}
     * @property {number} LOCATION_TYPE_ORIGIN=0 LOCATION_TYPE_ORIGIN value
     * @property {number} LOCATION_TYPE_DESTINATION=1 LOCATION_TYPE_DESTINATION value
     * @property {number} LOCATION_TYPE_ONGOING=2 LOCATION_TYPE_ONGOING value
     */
    ride_tracker.LocationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LOCATION_TYPE_ORIGIN"] = 0;
        values[valuesById[1] = "LOCATION_TYPE_DESTINATION"] = 1;
        values[valuesById[2] = "LOCATION_TYPE_ONGOING"] = 2;
        return values;
    })();

    /**
     * StopActionType enum.
     * @name ride_tracker.StopActionType
     * @enum {number}
     * @property {number} STOP_ACTION_PICKUP=0 STOP_ACTION_PICKUP value
     * @property {number} STOP_ACTION_DROP_OFF=1 STOP_ACTION_DROP_OFF value
     * @property {number} STOP_ACTION_STOP_BY=2 STOP_ACTION_STOP_BY value
     */
    ride_tracker.StopActionType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STOP_ACTION_PICKUP"] = 0;
        values[valuesById[1] = "STOP_ACTION_DROP_OFF"] = 1;
        values[valuesById[2] = "STOP_ACTION_STOP_BY"] = 2;
        return values;
    })();

    ride_tracker.Parcel = (function() {

        /**
         * Properties of a Parcel.
         * @memberof ride_tracker
         * @interface IParcel
         * @property {string|null} [name] Parcel name
         * @property {string|null} [note] Parcel note
         */

        /**
         * Constructs a new Parcel.
         * @memberof ride_tracker
         * @classdesc Represents a Parcel.
         * @implements IParcel
         * @constructor
         * @param {ride_tracker.IParcel=} [p] Properties to set
         */
        function Parcel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Parcel name.
         * @member {string} name
         * @memberof ride_tracker.Parcel
         * @instance
         */
        Parcel.prototype.name = "";

        /**
         * Parcel note.
         * @member {string} note
         * @memberof ride_tracker.Parcel
         * @instance
         */
        Parcel.prototype.note = "";

        /**
         * Creates a new Parcel instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Parcel
         * @static
         * @param {ride_tracker.IParcel=} [properties] Properties to set
         * @returns {ride_tracker.Parcel} Parcel instance
         */
        Parcel.create = function create(properties) {
            return new Parcel(properties);
        };

        /**
         * Encodes the specified Parcel message. Does not implicitly {@link ride_tracker.Parcel.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Parcel
         * @static
         * @param {ride_tracker.IParcel} m Parcel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Parcel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.note != null && Object.hasOwnProperty.call(m, "note"))
                w.uint32(18).string(m.note);
            return w;
        };

        /**
         * Decodes a Parcel message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Parcel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Parcel} Parcel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Parcel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Parcel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.note = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Parcel message.
         * @function verify
         * @memberof ride_tracker.Parcel
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Parcel.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.name != null && m.hasOwnProperty("name")) {
                if (!$util.isString(m.name))
                    return "name: string expected";
            }
            if (m.note != null && m.hasOwnProperty("note")) {
                if (!$util.isString(m.note))
                    return "note: string expected";
            }
            return null;
        };

        /**
         * Creates a Parcel message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Parcel
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Parcel} Parcel
         */
        Parcel.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Parcel)
                return d;
            var m = new $root.ride_tracker.Parcel();
            if (d.name != null) {
                m.name = String(d.name);
            }
            if (d.note != null) {
                m.note = String(d.note);
            }
            return m;
        };

        /**
         * Creates a plain object from a Parcel message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Parcel
         * @static
         * @param {ride_tracker.Parcel} m Parcel
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Parcel.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.name = "";
                d.note = "";
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = m.name;
            }
            if (m.note != null && m.hasOwnProperty("note")) {
                d.note = m.note;
            }
            return d;
        };

        /**
         * Converts this Parcel to JSON.
         * @function toJSON
         * @memberof ride_tracker.Parcel
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Parcel.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Parcel;
    })();

    /**
     * DivisionType enum.
     * @name ride_tracker.DivisionType
     * @enum {number}
     * @property {number} DIVISION_TYPE_TRANSPORTATION=0 DIVISION_TYPE_TRANSPORTATION value
     * @property {number} DIVISION_TYPE_DELIVERY=1 DIVISION_TYPE_DELIVERY value
     */
    ride_tracker.DivisionType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DIVISION_TYPE_TRANSPORTATION"] = 0;
        values[valuesById[1] = "DIVISION_TYPE_DELIVERY"] = 1;
        return values;
    })();

    ride_tracker.ETA = (function() {

        /**
         * Properties of a ETA.
         * @memberof ride_tracker
         * @interface IETA
         * @property {ride_tracker.IETARange|null} [range] ETA range
         * @property {number|null} [minutesLeft] ETA minutesLeft
         */

        /**
         * Constructs a new ETA.
         * @memberof ride_tracker
         * @classdesc Represents a ETA.
         * @implements IETA
         * @constructor
         * @param {ride_tracker.IETA=} [p] Properties to set
         */
        function ETA(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ETA range.
         * @member {ride_tracker.IETARange|null|undefined} range
         * @memberof ride_tracker.ETA
         * @instance
         */
        ETA.prototype.range = null;

        /**
         * ETA minutesLeft.
         * @member {number} minutesLeft
         * @memberof ride_tracker.ETA
         * @instance
         */
        ETA.prototype.minutesLeft = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ETA instance using the specified properties.
         * @function create
         * @memberof ride_tracker.ETA
         * @static
         * @param {ride_tracker.IETA=} [properties] Properties to set
         * @returns {ride_tracker.ETA} ETA instance
         */
        ETA.create = function create(properties) {
            return new ETA(properties);
        };

        /**
         * Encodes the specified ETA message. Does not implicitly {@link ride_tracker.ETA.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.ETA
         * @static
         * @param {ride_tracker.IETA} m ETA message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ETA.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.range != null && Object.hasOwnProperty.call(m, "range"))
                $root.ride_tracker.ETARange.encode(m.range, w.uint32(10).fork()).ldelim();
            if (m.minutesLeft != null && Object.hasOwnProperty.call(m, "minutesLeft"))
                w.uint32(16).int64(m.minutesLeft);
            return w;
        };

        /**
         * Decodes a ETA message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.ETA
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.ETA} ETA
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ETA.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.ETA();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.range = $root.ride_tracker.ETARange.decode(r, r.uint32());
                    break;
                case 2:
                    m.minutesLeft = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a ETA message.
         * @function verify
         * @memberof ride_tracker.ETA
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ETA.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.range != null && m.hasOwnProperty("range")) {
                {
                    var e = $root.ride_tracker.ETARange.verify(m.range);
                    if (e)
                        return "range." + e;
                }
            }
            if (m.minutesLeft != null && m.hasOwnProperty("minutesLeft")) {
                if (!$util.isInteger(m.minutesLeft) && !(m.minutesLeft && $util.isInteger(m.minutesLeft.low) && $util.isInteger(m.minutesLeft.high)))
                    return "minutesLeft: integer|Long expected";
            }
            return null;
        };

        /**
         * Creates a ETA message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.ETA
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.ETA} ETA
         */
        ETA.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.ETA)
                return d;
            var m = new $root.ride_tracker.ETA();
            if (d.range != null) {
                if (typeof d.range !== "object")
                    throw TypeError(".ride_tracker.ETA.range: object expected");
                m.range = $root.ride_tracker.ETARange.fromObject(d.range);
            }
            if (d.minutesLeft != null) {
                if ($util.Long)
                    (m.minutesLeft = $util.Long.fromValue(d.minutesLeft)).unsigned = false;
                else if (typeof d.minutesLeft === "string")
                    m.minutesLeft = parseInt(d.minutesLeft, 10);
                else if (typeof d.minutesLeft === "number")
                    m.minutesLeft = d.minutesLeft;
                else if (typeof d.minutesLeft === "object")
                    m.minutesLeft = new $util.LongBits(d.minutesLeft.low >>> 0, d.minutesLeft.high >>> 0).toNumber();
            }
            return m;
        };

        /**
         * Creates a plain object from a ETA message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.ETA
         * @static
         * @param {ride_tracker.ETA} m ETA
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ETA.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.range = null;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, false);
                    d.minutesLeft = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.minutesLeft = o.longs === String ? "0" : 0;
            }
            if (m.range != null && m.hasOwnProperty("range")) {
                d.range = $root.ride_tracker.ETARange.toObject(m.range, o);
            }
            if (m.minutesLeft != null && m.hasOwnProperty("minutesLeft")) {
                if (typeof m.minutesLeft === "number")
                    d.minutesLeft = o.longs === String ? String(m.minutesLeft) : m.minutesLeft;
                else
                    d.minutesLeft = o.longs === String ? $util.Long.prototype.toString.call(m.minutesLeft) : o.longs === Number ? new $util.LongBits(m.minutesLeft.low >>> 0, m.minutesLeft.high >>> 0).toNumber() : m.minutesLeft;
            }
            return d;
        };

        /**
         * Converts this ETA to JSON.
         * @function toJSON
         * @memberof ride_tracker.ETA
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ETA.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ETA;
    })();

    ride_tracker.ETARange = (function() {

        /**
         * Properties of a ETARange.
         * @memberof ride_tracker
         * @interface IETARange
         * @property {google.protobuf.ITimestamp|null} [from] ETARange from
         * @property {google.protobuf.ITimestamp|null} [to] ETARange to
         */

        /**
         * Constructs a new ETARange.
         * @memberof ride_tracker
         * @classdesc Represents a ETARange.
         * @implements IETARange
         * @constructor
         * @param {ride_tracker.IETARange=} [p] Properties to set
         */
        function ETARange(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ETARange from.
         * @member {google.protobuf.ITimestamp|null|undefined} from
         * @memberof ride_tracker.ETARange
         * @instance
         */
        ETARange.prototype.from = null;

        /**
         * ETARange to.
         * @member {google.protobuf.ITimestamp|null|undefined} to
         * @memberof ride_tracker.ETARange
         * @instance
         */
        ETARange.prototype.to = null;

        /**
         * Creates a new ETARange instance using the specified properties.
         * @function create
         * @memberof ride_tracker.ETARange
         * @static
         * @param {ride_tracker.IETARange=} [properties] Properties to set
         * @returns {ride_tracker.ETARange} ETARange instance
         */
        ETARange.create = function create(properties) {
            return new ETARange(properties);
        };

        /**
         * Encodes the specified ETARange message. Does not implicitly {@link ride_tracker.ETARange.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.ETARange
         * @static
         * @param {ride_tracker.IETARange} m ETARange message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ETARange.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.from != null && Object.hasOwnProperty.call(m, "from"))
                $root.google.protobuf.Timestamp.encode(m.from, w.uint32(10).fork()).ldelim();
            if (m.to != null && Object.hasOwnProperty.call(m, "to"))
                $root.google.protobuf.Timestamp.encode(m.to, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ETARange message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.ETARange
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.ETARange} ETARange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ETARange.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.ETARange();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.from = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.to = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a ETARange message.
         * @function verify
         * @memberof ride_tracker.ETARange
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ETARange.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.from != null && m.hasOwnProperty("from")) {
                {
                    var e = $root.google.protobuf.Timestamp.verify(m.from);
                    if (e)
                        return "from." + e;
                }
            }
            if (m.to != null && m.hasOwnProperty("to")) {
                {
                    var e = $root.google.protobuf.Timestamp.verify(m.to);
                    if (e)
                        return "to." + e;
                }
            }
            return null;
        };

        /**
         * Creates a ETARange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.ETARange
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.ETARange} ETARange
         */
        ETARange.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.ETARange)
                return d;
            var m = new $root.ride_tracker.ETARange();
            if (d.from != null) {
                if (typeof d.from !== "object")
                    throw TypeError(".ride_tracker.ETARange.from: object expected");
                m.from = $root.google.protobuf.Timestamp.fromObject(d.from);
            }
            if (d.to != null) {
                if (typeof d.to !== "object")
                    throw TypeError(".ride_tracker.ETARange.to: object expected");
                m.to = $root.google.protobuf.Timestamp.fromObject(d.to);
            }
            return m;
        };

        /**
         * Creates a plain object from a ETARange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.ETARange
         * @static
         * @param {ride_tracker.ETARange} m ETARange
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ETARange.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.from = null;
                d.to = null;
            }
            if (m.from != null && m.hasOwnProperty("from")) {
                d.from = $root.google.protobuf.Timestamp.toObject(m.from, o);
            }
            if (m.to != null && m.hasOwnProperty("to")) {
                d.to = $root.google.protobuf.Timestamp.toObject(m.to, o);
            }
            return d;
        };

        /**
         * Converts this ETARange to JSON.
         * @function toJSON
         * @memberof ride_tracker.ETARange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ETARange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ETARange;
    })();

    /**
     * RideType enum.
     * @name ride_tracker.RideType
     * @enum {number}
     * @property {number} RIDE_TYPE_RIDER=0 RIDE_TYPE_RIDER value
     * @property {number} RIDE_TYPE_SENDER=1 RIDE_TYPE_SENDER value
     * @property {number} RIDE_TYPE_RECIPIENT=2 RIDE_TYPE_RECIPIENT value
     * @property {number} RIDE_TYPE_SENDER_AND_RECIPIENT=3 RIDE_TYPE_SENDER_AND_RECIPIENT value
     */
    ride_tracker.RideType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RIDE_TYPE_RIDER"] = 0;
        values[valuesById[1] = "RIDE_TYPE_SENDER"] = 1;
        values[valuesById[2] = "RIDE_TYPE_RECIPIENT"] = 2;
        values[valuesById[3] = "RIDE_TYPE_SENDER_AND_RECIPIENT"] = 3;
        return values;
    })();

    ride_tracker.Company = (function() {

        /**
         * Properties of a Company.
         * @memberof ride_tracker
         * @interface ICompany
         * @property {string|null} [name] Company name
         * @property {string|null} [logo] Company logo
         */

        /**
         * Constructs a new Company.
         * @memberof ride_tracker
         * @classdesc Represents a Company.
         * @implements ICompany
         * @constructor
         * @param {ride_tracker.ICompany=} [p] Properties to set
         */
        function Company(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Company name.
         * @member {string} name
         * @memberof ride_tracker.Company
         * @instance
         */
        Company.prototype.name = "";

        /**
         * Company logo.
         * @member {string} logo
         * @memberof ride_tracker.Company
         * @instance
         */
        Company.prototype.logo = "";

        /**
         * Creates a new Company instance using the specified properties.
         * @function create
         * @memberof ride_tracker.Company
         * @static
         * @param {ride_tracker.ICompany=} [properties] Properties to set
         * @returns {ride_tracker.Company} Company instance
         */
        Company.create = function create(properties) {
            return new Company(properties);
        };

        /**
         * Encodes the specified Company message. Does not implicitly {@link ride_tracker.Company.verify|verify} messages.
         * @function encode
         * @memberof ride_tracker.Company
         * @static
         * @param {ride_tracker.ICompany} m Company message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Company.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.logo != null && Object.hasOwnProperty.call(m, "logo"))
                w.uint32(18).string(m.logo);
            return w;
        };

        /**
         * Decodes a Company message from the specified reader or buffer.
         * @function decode
         * @memberof ride_tracker.Company
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {ride_tracker.Company} Company
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Company.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.ride_tracker.Company();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.logo = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Verifies a Company message.
         * @function verify
         * @memberof ride_tracker.Company
         * @static
         * @param {Object.<string,*>} m Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Company.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.name != null && m.hasOwnProperty("name")) {
                if (!$util.isString(m.name))
                    return "name: string expected";
            }
            if (m.logo != null && m.hasOwnProperty("logo")) {
                if (!$util.isString(m.logo))
                    return "logo: string expected";
            }
            return null;
        };

        /**
         * Creates a Company message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ride_tracker.Company
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {ride_tracker.Company} Company
         */
        Company.fromObject = function fromObject(d) {
            if (d instanceof $root.ride_tracker.Company)
                return d;
            var m = new $root.ride_tracker.Company();
            if (d.name != null) {
                m.name = String(d.name);
            }
            if (d.logo != null) {
                m.logo = String(d.logo);
            }
            return m;
        };

        /**
         * Creates a plain object from a Company message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ride_tracker.Company
         * @static
         * @param {ride_tracker.Company} m Company
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Company.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.name = "";
                d.logo = "";
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = m.name;
            }
            if (m.logo != null && m.hasOwnProperty("logo")) {
                d.logo = m.logo;
            }
            return d;
        };

        /**
         * Converts this Company to JSON.
         * @function toJSON
         * @memberof ride_tracker.Company
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Company.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Company;
    })();

    /**
     * CanceledBy enum.
     * @name ride_tracker.CanceledBy
     * @enum {number}
     * @property {number} CANCELED_BY_UNSPECIFIED=0 CANCELED_BY_UNSPECIFIED value
     * @property {number} CANCELED_BY_DRIVER=1 CANCELED_BY_DRIVER value
     * @property {number} CANCELED_BY_CC=2 CANCELED_BY_CC value
     * @property {number} CANCELED_BY_API=3 CANCELED_BY_API value
     * @property {number} CANCELED_BY_BOOKER=4 CANCELED_BY_BOOKER value
     * @property {number} CANCELED_BY_RIDER=5 CANCELED_BY_RIDER value
     */
    ride_tracker.CanceledBy = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CANCELED_BY_UNSPECIFIED"] = 0;
        values[valuesById[1] = "CANCELED_BY_DRIVER"] = 1;
        values[valuesById[2] = "CANCELED_BY_CC"] = 2;
        values[valuesById[3] = "CANCELED_BY_API"] = 3;
        values[valuesById[4] = "CANCELED_BY_BOOKER"] = 4;
        values[valuesById[5] = "CANCELED_BY_RIDER"] = 5;
        return values;
    })();

    return ride_tracker;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Empty = (function() {

            /**
             * Properties of an Empty.
             * @memberof google.protobuf
             * @interface IEmpty
             */

            /**
             * Constructs a new Empty.
             * @memberof google.protobuf
             * @classdesc Represents an Empty.
             * @implements IEmpty
             * @constructor
             * @param {google.protobuf.IEmpty=} [p] Properties to set
             */
            function Empty(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Creates a new Empty instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty=} [properties] Properties to set
             * @returns {google.protobuf.Empty} Empty instance
             */
            Empty.create = function create(properties) {
                return new Empty(properties);
            };

            /**
             * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty} m Empty message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Empty.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                return w;
            };

            /**
             * Decodes an Empty message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Empty
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Empty} Empty
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Empty.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Empty();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * Verifies an Empty message.
             * @function verify
             * @memberof google.protobuf.Empty
             * @static
             * @param {Object.<string,*>} m Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Empty.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an Empty message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Empty
             * @static
             * @param {Object.<string,*>} d Plain object
             * @returns {google.protobuf.Empty} Empty
             */
            Empty.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.Empty)
                    return d;
                return new $root.google.protobuf.Empty();
            };

            /**
             * Creates a plain object from an Empty message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.Empty} m Empty
             * @param {$protobuf.IConversionOptions} [o] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Empty.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Empty to JSON.
             * @function toJSON
             * @memberof google.protobuf.Empty
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Empty.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Empty;
        })();

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [p] Properties to set
             */
            function Timestamp(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} m Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.seconds != null && Object.hasOwnProperty.call(m, "seconds"))
                    w.uint32(8).int64(m.seconds);
                if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos"))
                    w.uint32(16).int32(m.nanos);
                return w;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Timestamp();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.seconds = r.int64();
                        break;
                    case 2:
                        m.nanos = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} m Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.seconds != null && m.hasOwnProperty("seconds")) {
                    if (!$util.isInteger(m.seconds) && !(m.seconds && $util.isInteger(m.seconds.low) && $util.isInteger(m.seconds.high)))
                        return "seconds: integer|Long expected";
                }
                if (m.nanos != null && m.hasOwnProperty("nanos")) {
                    if (!$util.isInteger(m.nanos))
                        return "nanos: integer expected";
                }
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} d Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.Timestamp)
                    return d;
                var m = new $root.google.protobuf.Timestamp();
                if (d.seconds != null) {
                    if ($util.Long)
                        (m.seconds = $util.Long.fromValue(d.seconds)).unsigned = false;
                    else if (typeof d.seconds === "string")
                        m.seconds = parseInt(d.seconds, 10);
                    else if (typeof d.seconds === "number")
                        m.seconds = d.seconds;
                    else if (typeof d.seconds === "object")
                        m.seconds = new $util.LongBits(d.seconds.low >>> 0, d.seconds.high >>> 0).toNumber();
                }
                if (d.nanos != null) {
                    m.nanos = d.nanos | 0;
                }
                return m;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} m Timestamp
             * @param {$protobuf.IConversionOptions} [o] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    if ($util.Long) {
                        var n = new $util.Long(0, 0, false);
                        d.seconds = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                    } else
                        d.seconds = o.longs === String ? "0" : 0;
                    d.nanos = 0;
                }
                if (m.seconds != null && m.hasOwnProperty("seconds")) {
                    if (typeof m.seconds === "number")
                        d.seconds = o.longs === String ? String(m.seconds) : m.seconds;
                    else
                        d.seconds = o.longs === String ? $util.Long.prototype.toString.call(m.seconds) : o.longs === Number ? new $util.LongBits(m.seconds.low >>> 0, m.seconds.high >>> 0).toNumber() : m.seconds;
                }
                if (m.nanos != null && m.hasOwnProperty("nanos")) {
                    d.nanos = m.nanos;
                }
                return d;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Timestamp;
        })();

        return protobuf;
    })();

    return google;
})();

export { $root as default };
